/**
 * SCHWEBE-SYSTEM — EINE live berechnete Standlinie fuer alles, was ueber der
 * Seite schwebt (Feinschliff II, Abschnitt D; Betreiber 26.09.2026: „denk …
 * auch an diese google icons, chat icons und to-top icon, die muessen perfekt
 * integriert sein und sich bewegen wenn z.b. das panel unten kommt").
 *
 * Diese Datei MISST nur und setzt Zustaende; wie die Schwebenden darauf
 * reagieren, steht in assets/automotive.css (Abschnitt „SCHWEBENDE
 * BEDIENELEMENTE") und — fuer die Laschen — in assets/ap-header-nav.css.
 *
 * ===========================================================================
 * INVENTUR am echten DOM (26.09.2026, Headless-Chrome per CDP mit echter
 * Mobil-Emulation, Messskript alle position:fixed/sticky-Elemente inkl.
 * offener Shadow-Roots; LIVE = Theme 204430606675, VORSCHAU = 207804891475
 * vor diesem Umbau). Kasten „x,y BxH", u = Abstand Unterkante -> Bildrand.
 * ===========================================================================
 *
 *  Element / Wirt (Herkunft, z-index)     LIVE 390x844        LIVE 1440x900       VORSCHAU 390         VORSCHAU 1440
 *  ------------------------------------   ------------------  ------------------  -------------------  -------------------
 *  Inbox-Chat  shopify-chat (App, fixed,  284,778 86x46 u20   1334,834 86x46 u20  284,710 u88 (!)      1334,766 u88 (!)
 *    ganzer Viewport, pointer-events none, PDP u104           PDP u156            PDP u172             PDP u164
 *    z 2147483000) > .activator-nudge
 *    (absolute) > button[part=activator]
 *  „Nach oben" .ap-to-top (Theme, z 50)   326,716 44x44 u84   1262,828 48x48 u24  326,716 44x44 u84    1382,768 48x48 u84
 *                                         PDP u164 (Kreis)    PDP u156, INHALT-   = UEBER der Blase:   = UEBER der Blase:
 *                                                             SPALTE              1760 px2 (PDP 1584)  1672 px2 (PDP 1520)
 *  Google-Abzeichen                       /cart 0,752 68x68   20,792 84x84 u24    geparkt links (hid-  4,819 57x57 u24
 *    #google-merchantwidget-iframe-       u24 (sonst im Head- PDP u156            den), angedockt am   (Rand, scale .68)
 *    wrapper (App, z 2147483647)          less 0x0)                               Fussende             PDP u96
 *  Judge.me-Lasche .jdgm-revs-tab-btn     353,364 37x153      1402,417 38x161     352,365 38x153       1402,421 38x153
 *    in section.jdgm-revs-tab (App,       (nur beim Hoch-     u323                (nur beim Hoch-      u326
 *    z auto, Rahmen 1041), gedreht        scrollen)                               scrollen)
 *  Anruf-Lasche ap-call-tab (Theme, z 50) 353,257 37x107      1402,310 38x107     352,260 38x105       1402,316 38x105
 *  Kaufleiste sticky-atc (Theme, z 4)     0,754 390x90 schon  170,780 1100x120    0,753 390x91 erst    64,815 1312x85
 *    = UNTERES HINDERNIS                  bei scrollY 0                           nach Preis+Knopf
 *  Cookie-Banner pandectes-cmp (Shadow-   45,294 300x256      570,298 300x304     45,305 300x235       570,309 300x283
 *    Wirt) > dialog.notice.box (z 10)     MITTIG, nicht unten; nach „Akzeptieren" aus dem DOM. #shopify-pc__banner
 *                                         (Shopifys eigener Banner) gibt es seit Pandectes nicht mehr.
 *  Vorschauleiste #PBarNextFrameWrapper   —                   —                   0,776 390x68         0,832 1440x68
 *    (nur ?preview_theme_id, fixed unten)
 *  Kopf .section-header (sticky, z 11), Galerie/Datenblatt-Spalten (sticky im Fluss) — oben bzw. im Inhalt, kein
 *    Schwebe-Konflikt.
 *  Nicht vorhanden (gesucht, 0 Treffer): Trusted-Shops-Trustbadge [id^=trustbadge-container] (kein TSID; das
 *    Siegel-System laedt es nur mit echter Kennung und nur ab 990 px), authorized.by-Schwebeplatz
 *    body > [data-authorizedby-place], Shop-App-Folgen-Knopf, ein Judge.me-ABZEICHEN (im App-Embed sind
 *    popup_widget und cart_drawer_widget aus, an ist nur reviews_tab = die Lasche rechts).
 *
 *  Zustaende (gleiche Laeufe):
 *    Schublade offen   Blase scale(0), „Nach oben"/Laschen hidden; Google nur mobil hidden (1440: 4,747 sichtbar
 *                      ueber dem Schleier).
 *    Handy-Menue, Suchmodal, Filterlade   alle Schwebenden weg.
 *    Mega-Menue 1440   NICHTS weg: die Blase 1334,766 lag auf der unteren rechten Ecke des offenen Menues
 *                      (64..1376 x 128..860).
 *    PDP Vorschau 390  scrollY 0: keine Leiste, trotzdem Standlinie 104 (Klasse der SEITE) — die Blase schwebte
 *                      bei u172 grundlos hoch; LIVE steht die Leiste schon bei scrollY 0.
 *
 *  Befunde, aus denen dieser Umbau folgt:
 *    1. „Nach oben" und Blase ueberlappen in der Vorschau auf JEDER Seite: die Stapelregel rechnete mit einer
 *       Blase auf der Standlinie (Unterkante 24), die Blase sitzt in der Vorschau aber bei 88 (App rechnet die
 *       68-px-Vorschauleiste selbst ein, siehe unten) und live bei 20 — eine Annahme statt einer Messung.
 *    2. Die Standlinie hing an der SEITE (body.ap-has-sticky-atc), nicht an der Leiste: ohne Leiste standen
 *       Blase und Knopf 80 px zu hoch, mit Leiste passte es nur, weil die Zahl im CSS zufaellig stimmte.
 *    3. Beim Mega-Menue blieb alles stehen; eine Bildschirmtastatur kannte das System gar nicht.
 *    4. Drei Formen, drei Groessen: Kreis 44 (live), Karte 44/48 (Vorschau), Pille 86x46 Radius 16 (App).
 *
 * ===========================================================================
 * MESSNACHWEIS zu den FREMD-Widgets (Muster assets/ap-app-a11y.js) — das
 * Theme richtet sie nur ueber ihre Wirtsknoten bzw. freigegebene Teile aus.
 * ===========================================================================
 *
 *  Inbox-Chat. Shadow-Root OFFEN, einziger freigegebener Teil `part="activator"`
 *    (<button class="activator" aria-label="Chat">, display grid, padding 0 16px,
 *    Hoehe --private-activator-height = 46px, Radius 16, Grund color(srgb 1 1 1/.7)).
 *    Seine Lage steht NICHT am Knopf, sondern an .activator-nudge:
 *      bottom: calc(var(--shopify-chat-activator-offset) + var(--private-preview-bar-offset, 0px))
 *    Beide Variablen erbt ::part(activator) aus seinem Schattenbaum. Deshalb rechnet die CSS-Regel den Hub als
 *      translate: … calc(var(--shopify-chat-activator-offset, 20px) + var(--private-preview-bar-offset, 0px)
 *                       - var(--ap-float-floor))
 *    und setzt die Unterkante damit GENAU auf die Standlinie — egal, welchen Abstand die App-Einstellung
 *    („lowest" = 20 px) oder die Vorschauleiste (+68) gerade liefert. Faellt ein Variablenname weg, greift
 *    der Rueckfall (20 px / 0 px) und es bleibt beim heutigen Stand. Seitenregeln auf ::part schlagen die
 *    Regeln im Schattenbaum (aeusserer Kontext gewinnt bei normalen Deklarationen) — kein !important noetig.
 *    Ausblenden bleibt transform: scale(0) am WIRT (visibility/pointer-events setzt das offene Chatfenster
 *    zurueck, belegt 10.08.2026, siehe automotive.css).
 *  Judge.me-Lasche. INLINE-Stil der App: `background-color: rgb(251, 205, 10); color: rgb(255, 255, 255);
 *    padding: 8px 16px` (nicht bei jedem Laden — im zweiten Lauf fehlte padding im Inline-Stil, die Lasche
 *    war dann 121 statt 153 px lang), gedreht per transform matrix(0, 1, -1, 0, -h/2, w/2) um die rechte
 *    Mitte. 8 + 22,4 + 8 = 38,4 px Dicke — unter der Tippflaeche von 44 px. Die Dicke folgt der
 *    Polsterung (ap-header-nav.css setzt beide Achsen, nur dort !important gegen den Inline-Stil); mit 44 px
 *    nachgemessen matrix(0, 1, -1, 0, -22.2, 60.4) = die Drehung rechnet in Prozent, die Lage bleibt
 *    buendig. Farben, Text und Lage bleiben die der App.
 *  Google-Abzeichen. Die App setzt bottom inline mit !important (Befund 08.09., automotive.js
 *    „platziereAbzeichen") — der Hub bleibt dort als Inline-transform; diese Datei meldet ihm nur jede
 *    Aenderung der Standlinie (Ereignis `ap:standlinie`).
 *  Pandectes. Shadow-Root OFFEN; der Banner ist ein mittiger Dialog (translate -50 %/-50 %). Er zaehlt nur als
 *    Hindernis, wenn er am unteren Rand steht (anderes Layout im Pandectes-Admin) — dann gleitet alles darueber.
 *
 * ===========================================================================
 * WAS DIESE DATEI TUT
 * ===========================================================================
 *  1. STANDLINIE UND EIN HUB. Hoehe des hoechsten gerade sichtbaren UNTEREN Hindernisses (Kaufleiste nach
 *     ihrem Zielzustand .is-visible, ein unten verankerter Cookie-Banner) -> Standlinie in px, dieselbe Formel
 *     wie im CSS: max(--ap-float-rest, Hindernis + --ap-float-gap). Ausloeser: ResizeObserver (Leiste,
 *     Banner), MutationObserver (Klasse/hidden der Leiste, neue Wirte am <body>, Pandectes-Schattenbaum),
 *     visualViewport, resize, Zustimmungs-Ereignis. Die Shopify-Vorschauleiste (#PBarNextFrameWrapper, nur
 *     mit ?preview_theme_id) zaehlt NICHT (Phase B, Pruefrunde 1, G2): es gibt sie live nie.
 *     GEAENDERT Feinschliff 3 (03.10.2026, Betreiber: „die drei icons … mal weg mal kommen die mal springt
 *     ein icons auf die falsche position und richtet sich wieder"): die rechte Spalte (Chat-Blase, KI-Platz,
 *     „Nach oben") bewegt sich senkrecht mit EINER Uhr. Diese Datei rechnet den Zwischenwert selbst (ohne
 *     Lesezugriff) und schreibt ihn in jedem Bild an genau drei Elemente: am Wirt der Blase als
 *     --shopify-chat-activator-offset (die App-Variable — die Trefferflaeche wandert mit), an .ap-ki und
 *     .ap-to-top als --ap-schwebe-hub (senkrechtes translate, KEINE CSS-Transition darauf). Kurve und Dauer
 *     der Kaufleiste (cubic-bezier(.2,.6,.2,1) = --ap-ease, --ap-motion, mindestens 200 ms); STEIGT die
 *     Standlinie, startet die Uhr in dem Bild, in dem die Leiste ihre Klasse bekommt (Zeit der Zeitleiste —
 *     dieselbe, mit der ihre Transition startet: die Spalte bleibt Bild fuer Bild ueber ihr), SINKT sie (die
 *     Leiste ist dann schon weg), im ersten Bild danach (G5: ein langes Bild verschluckt sonst die Blende).
 *     prefers-reduced-motion: springen. Gemessen vorher (Analyse Feinschliff 3, 19 Laeufe): drei Uhren —
 *     JS-Blende nur der Blase beim Sinken, CSS-Transitionen fuer KI und „Nach oben" —, der KI-Knopf lag bei
 *     8 von 8 sichtbaren Absenkungen 100–170 ms auf bzw. hinter der Blase (Luft −11 bis −69 px).
 *     GEAENDERT Feinschliff 3 FIX (04.10.2026, gegnerische Pruefung Mobil, major): die JS-Uhr bekam unter
 *     Hauptfaden-Last (Mittelklasse-Handy ~ CPU-Drossel 4x) nur 2–3 Bilder je 200-ms-Gleiten — die Spalte
 *     sprang in 30–40-px-Stufen hinter der glatt gleitenden Leiste her (Trace: hubSchritt-Abstaende 69–244 ms
 *     statt 16,7). Jetzt laeuft der Hub auf dem COMPOSITOR wie die Leiste selbst: diese Datei schreibt den
 *     ZIELWERT einmal je Zustandswechsel als --ap-schwebe-hub an die drei Elemente (Wirt der Blase, .ap-ki,
 *     .ap-to-top) — im selben Mikrotask wie der Klassenwechsel der Leiste (MutationObserver) —, und jedes traegt
 *     `translate: 0 var(--ap-schwebe-hub)` mit `translate var(--ap-motion) var(--ap-ease)` in seiner
 *     transition-Liste (automotive.css, ap-ki-widget.css). Alle vier Transitionen starten damit im selben
 *     Stilschritt und laufen lastunabhaengig synchron; eine Umkehr mitten im Gleiten uebernimmt der Browser vom
 *     Zwischenwert. Die Blase: ihr WIRT shopify-chat gleitet per translate (Treffertest folgt), die App-Variable
 *     --shopify-chat-activator-offset steht statisch auf der Ruhelage. Ausnahme offenes Chatfenster
 *     (shopify-chat[open], gemessen 04.10.: das Desktop-Fenster legt seine Unterkante selbst auf die
 *     App-Variable und passt die Hoehe an, das Handy-Fenster steht fest — mit translate rutschte es bei
 *     844 x 390 um 68 px aus dem Bild): dann kein translate, die Variable traegt die Standlinie (wie vorher);
 *     beim Schliessen steht die Blase ohne Gleiten auf ihrem Hub (Transition fuer zwei Bilder aus).
 *     prefers-reduced-motion: keine Transition (springen).
 *     --ap-float-hindernis wird NICHT mehr an <html> geschrieben: jede Aenderung erzwang eine
 *     Stil-Neuberechnung des GANZEN Dokuments (gemessen 59 ms je Schreiben + Lesen, 89 ms je Absenken).
 *     --ap-float-floor bleibt damit im CSS die Ruhelage; die statische Seiten-Standlinie
 *     --ap-float-floor-seite (Kaufleiste moeglich: ihre Hoehe + Luft, sonst die Ruhelage) traegt die
 *     Fussreserve (sections/footer.liquid, section-footer.css) — ein Hub verlegt kein Dokument mehr.
 *     Wer etwas Schwebendes per JS platziert (Google-Abzeichen), hoert auf das Ereignis ap:standlinie.
 *     Solange html[data-ap-standlinie] fehlt (altes Geraet ohne ResizeObserver, Skript blockiert), gilt der
 *     Seitenwert an body.ap-has-sticky-atc als Rueckfall (html:not([data-ap-standlinie])).
 *  2. AUSWEICHEN — NUR IN RUHE, EINE SPALTE. Liegt ein geschuetztes Ziel der Seite (Liste SCHUTZ: Preise,
 *     Kaufknoepfe, Mengen- und Satzwahl, Karten-Kaufknoepfe, Warenkorbsummen, „Zur Kasse", Finder,
 *     Seitenauswahl, Widerrufsknopf) unter IRGENDEINER Stufe der rechten Spalte (Blase, KI-Platz,
 *     „Nach oben"), gleitet die GANZE Spalte seitlich hinaus: html.ap-schwebe-weicht. Dasselbe fuer die
 *     Laschen (Mitte rechts): html.ap-laschen-weichen — auch, wenn sie in die rechte Spalte ragen (Handy
 *     quer) oder in den offenen KI-Hinweis (hinweisZone). Echte Ueberdeckung: je Achse mindestens
 *     WEICHEN_MIN px eines mindestens halb sichtbaren Ziels. Ab 750 px haelt der Seitenrand
 *     (--ap-gutter >= 52 px) den Inhalt aus der Laschenbahn.
 *     GEAENDERT Feinschliff 3 (03.10.2026): ENTSCHIEDEN WIRD NUR IN RUHE (Abschnitt 7) — waehrend Wischen
 *     und Nachlauf bleiben beide Klassen eingefroren (kein Hinaus, kein Zurueck), eine Bewegung je Halt.
 *     Vorher pruefte jedes Scroll-Bild: 282 von 310 Weichvorgaengen (91 %) fielen mitten in eine
 *     Wischgeste, 180 von 307 Rueckkehren kamen binnen 260 ms nach scrollend — „mal weg, mal da". Das
 *     getrennte Weichen des KI-Platzes (html.ap-ki-weicht, Gegenpruefung 03.10.2026) ist zurueckgenommen:
 *     es versetzte die Spalte (bis 68 px, bis 167 ms) und war nachgerechnet unruhiger als eine Spalte
 *     (Reifen-PDP: 30 Blase + 44 KI statt 18 Wechsel). „Zur Kasse" der Schublade und „Anwenden" der
 *     Filterlade schuetzt Punkt 4 (Lade offen = aus).
 *     GEAENDERT Feinschliff 3 FIX (04.10.2026, gegnerische Pruefung Mobil, major „Tippfalle nach jedem
 *     Halt"): mit nur EINER Schwelle blieb die Spalte nach dem Anhalten RUHE_MS + Leerlauf + Gleiten (gemessen
 *     1,27 s) ueber „In den Warenkorb", der Express-Kasse, der Satzwahl und „Zur Kasse" — ein Tipp traf den
 *     KI-Knopf (laedt sofort den Anbieter) oder oeffnete den Chat statt zu kaufen (echte Touch-Tipps, PDP
 *     390/360, /cart). Jetzt ZWEI Schwellen: HINAUS schon beim ersten stabilen Halt (HALT_MS ohne Regung, kein
 *     Finger) — nur gegen die KAUF-Liste (Teilmenge von SCHUTZ), nur ap-schwebe-weicht = true, nie zurueck,
 *     nie bei offener Lade; ZURUECK und alle uebrigen Ziele weiter erst in der Ruhe. Im Wischen bleibt es bei
 *     0 Bewegungen, je Halt hoechstens eine; die Falle schrumpft auf HALT_MS + Gleiten (~0,4 s).
 *     GEAENDERT Zusammenfuehrung 05.10.2026 (gegnerische Pruefung Mobil): (a) beim Ausweichen gibt die Spalte das
 *     Ziel im SELBEN Bild frei — der Wirt der Blase ist sofort verborgen, Blase/KI/„Nach oben" sofort ohne Treffer,
 *     sichtbar gleiten sie trotzdem hinaus (vorher ~240 ms eine unsichtbare, treffbare Chat-Flaeche, major);
 *     (b) ZURUECK gleitet die Spalte nicht mehr, sie steht an der Endlage und blendet ein (CSS „ZURUECK OHNE
 *     GLEITEN"), und ein Finger, der waehrend des Hinausgleitens aufsetzt, beendet es sofort (gleitenBeenden) —
 *     vorher lief das Gleiten in 4 von 13 Wischlaeufen 35–72 px unter dem Finger weiter.
 *     Offene Lade/Menue oder alles aus (ap-lade-offen, ap-schwebe-aus): KEINE Entscheidung — vorher setzte der
 *     Ruhe-Gang hinter dem offenen Handy-Menue ap-schwebe-weicht (Siegel-Kachel im Menue unter der Spalte),
 *     nach dem Schliessen fehlte die Spalte ~0,6 s. Beim Schliessen (Ereignis ap:lade aus Teil 1) wird neu
 *     entschieden, solange die Spalte noch verborgen ist (ap-lade-zu, Punkt 4).
 *     KI-TELEFON-WIDGET (01.10.2026, assets/ap-ki-widget.*): der Platz .ap-ki steht in der rechten Spalte
 *     zwischen Blase und „Nach oben" und zaehlt zu ihrer Hoehe; im Gespraech hat er die Groesse der Pille des
 *     Anbieters (Inline-Groesse, Ereignis ap:ki-platz; die Laschen weichen ihr), „Nach oben" ist dann
 *     verborgen und zaehlt nicht mit, und der Platz gleitet nie hinaus (die Pille ist die Bedienung des
 *     Gespraechs). Steht der Wirt der Inbox-Blase schon im Server-HTML, setzt Teil 1 html.ap-hat-chat bei
 *     DOMContentLoaded.
 *  3. AUS. Bildschirmtastatur (Eingabefeld der SEITE fokussiert und das Sichtfeld um >= 150 px geschrumpft)
 *     oder ein unteres Hindernis ueber der halben Bildhoehe: html.ap-schwebe-aus — sofort, ein echter Zustand.
 *  4. ZUSTANDSKLASSEN (Phase D, DT-2, 28.09.2026) — offene Laden, Menues und Modals als Klassen an <html>
 *     (html.ap-lade-offen, html.ap-leiste-weg, html.ap-schublade-offen; dazu html.ap-hat-chat und
 *     html.ap-hat-siegelseite). Bis hierher stand dafuer im CSS dokumentweit
 *       body:has(cart-drawer.active, .mobile-facets__disclosure[open], … , > .jdgm-modal) X
 *     neunmal (automotive.css, ap-siegel-kopf, section-sticky-atc, component-cart-drawer). Ein body:has()
 *     mit Klassen-/Attribut-Argument wird bei JEDER Aenderung von „active"/„open" irgendwo im Dokument neu
 *     bewertet und invalidiert vom <body> aus — gemessen (Lighthouse 28.09., PDP mobil) stieg „Style &
 *     Layout" um 40–120 %, dokumentweite body/html:has() 18 statt 12 live. Jetzt beobachtet EIN Wachposten
 *     genau diese Zustaende (Attribut „open" per MutationObserver mit attributeFilter, die Klasse der
 *     Schublade, direkte <body>-Kinder fuer das Judge.me-Fenster) und setzt die Klassen IM SELBEN Mikrotask
 *     (vor dem naechsten Bild). Kein JS-Umschalten an den sechs Oeffnen/Schliessen-Stellen: der Wachposten
 *     liest den ZUSTAND selbst, ein vergessener Weg kann nichts haengen lassen. Die Liste steht EINMAL
 *     (LADEN unten), die Probe tests/schwebende-standlinie.test.js haelt sie gegen die frueheren Zustaende.
 *     Diese Zustaende wirken SOFORT (auch mitten im Wischen) — sie sind echte Zustandswechsel.
 *     GEAENDERT Feinschliff 3 FIX (04.10.2026, minor „schlagartig zurueck"): Ausblenden bleibt sofort, das
 *     ZURUECKKOMMEN wartet die Schliessdauer der Lade ab (html.ap-lade-zu, LADE_ZU_MS) und blendet dann weich
 *     ein (opacity, automotive.css/ap-ki-widget.css). Vorher fiel ap-lade-offen schon mit dem Beginn der
 *     Schliess-Animation: die Blase (z 2147483000) stand ~330 ms VOR der noch sichtbaren Schublade, KI und
 *     „Nach oben" (z 50) dahinter — und alle drei kamen mit voller Deckkraft im ersten Bild. Jeder Wechsel
 *     meldet sich als Ereignis ap:lade { offen } an document.
 *     Nachmessung 05.10.2026 (Querformat 844 x 390): das Schliessen der Bildansicht SCROLLT die Seite (Dawn
 *     fokussiert den Oeffner, y 0 -> 297) — der Ruhe-Gang wartete auf die Ruhe, die Spalte erschien nach
 *     LADE_ZU_MS an ihrem Platz und glitt ~1,1 s spaeter hinaus. Jetzt faellt ap-lade-zu erst, wenn die
 *     Schliessdauer um ist UND der Ruhe-Gang nach dem Schliessen entschieden hat (Ereignis
 *     ap:schwebe-entschieden aus Teil 2), hoechstens LADE_ZU_MAX_MS nach dem Schliessen; ohne laufenden Teil 2
 *     (html.__apSchwebeBereit fehlt) nur die Schliessdauer. Entschieden wird im SCHLIESS-GANG (Teil 2): HALT_MS
 *     nach dem Schliessen bzw. nach dem letzten SCROLL, ohne Finger — nicht erst RUHE_MS nach dem Schliess-Tipp
 *     (dessen touchend ist eine Regung: sonst kam die Spalte 0,6–1,0 s nach dem Schliessen zurueck).
 *  5. KOSTEN (Phase D, DT-1, 28.09.2026). Lighthouse 28.09. (PDP mobil, Vorschau): ap-schwebe.js 5,2 s
 *     Gesamtzeit (1,5 s Skript + erzwungenes Style/Layout), live 0 — das teuerste Theme-Skript. Ursachen und
 *     Abhilfe: (a) der <body>-Beobachter rief bei JEDEM Kind-Wechsel (Apps haengen laufend Knoten an)
 *     pandectesSammeln() — getComputedStyle fuer bis zu 800 Knoten im Pandectes-Schattenbaum — jetzt wertet
 *     er nur hinzugefuegte/entfernte WIRTE aus; (b) der Beobachter im Schattenbaum sammelte und rechnete bei
 *     jeder Attributaenderung SOFORT — jetzt einmal je Bild und nur die Kandidaten (oberste Ebene, deren
 *     Kinder, Dialoge; hoechstens 12); (c) GEAENDERT Feinschliff 3: das Ausweichen (Abfrage der
 *     SCHUTZ-Liste, Kaesten der Ziele und Laschen) laeuft nur noch EINMAL je Ruhe — im Scroll-Pfad steht
 *     KEINE Layout-Lesung mehr (vorher steckte weichenPruefen in 910 langen Bildern mit 38,5 s Skriptzeit);
 *     (d) die Standlinie wird in JS gerechnet — die Sonde wird nur beim Start und nach einem Breiten-
 *     wechsel/Drehen geeicht (Rand, Abstand, Ruhelage, Luft, Groesse --ap-float-size, Dauer --ap-motion);
 *     Leistenhoehe aus dem ResizeObserver, Banner nur nach eigener Aenderung; (e) die Grundhoehe ohne
 *     Tastatur (innerHeight, visualViewport) wird nur nach resize neu gelesen.
 *     Probe PD-1: 200 <body>-Anhaenge in einer Aufgabe = hoechstens 1 Lauf je Bild und hoechstens 20
 *     getComputedStyle je Lauf (tests/schwebende-standlinie.test.js).
 *     GEAENDERT Feinschliff 3 FIX (04.10.2026, gegnerische Pruefung Mobil, major „Layout-Lesungen im
 *     Scroll-Pfad", Trace CPU 4x): (f) die Sichthoehe steht in sichtH — gelesen beim Start, nach resize/
 *     orientationchange und visualViewport-resize, nie mehr in hindernisRechnen (das lief im
 *     MutationObserver direkt nach dem Klassenwechsel der Leiste: 18x 212 ms erzwungene Stil-Neuberechnung);
 *     (g) die Leistenhoehe kommt NUR aus dem ResizeObserver (die letzte echte Hoehe bleibt, auch wenn die
 *     Leiste [hidden] ist) — kein offsetHeight im Beobachter-Pfad; (h) der Ruhe-Gang fragt die SCHUTZ-Liste
 *     nicht mehr je Halt ab (169 Treffer, Median 25,7 ms bei 1x, 157 ms bei 4x): EIN IntersectionObserver
 *     fuehrt die Ziele, die gerade im Bild stehen (Sammeln einmal im Leerlauf, neu nach DOM-Aenderungen in
 *     #MainContent, entprellt); je Halt werden nur diese (~12) vermessen. Ohne IntersectionObserver (bzw.
 *     vor seiner ersten Meldung) gilt die alte Abfrage als Rueckfall.
 *  6. STARTZEIT (Phase B, Pruefrunde 1, G2, 29.09.2026). PSI mobil: ap-schwebe.js kostete trotz DT-1 noch
 *     266–586 ms Hauptfaden auf Kollektion, Marke und Suche — der Teil 2 startete bei DOMContentLoaded und
 *     las Sonde, Chat-Knopf, Laschen und Ziele, waehrend die Seite noch baute. Jetzt: (a) Teil 2 startet
 *     nach `load` im Leerlauf (requestIdleCallback, spaetestens LEERLAUF_MS danach) — FRUEHER nur, wenn es
 *     etwas zu tun gibt: der erste scroll/resize, ein Fokus (Tastatur) oder die Kaufleiste kommt (sie steht
 *     auf Tablets schon im ersten Bildschirm, die Spalte gleitet dann sofort mit); (b) nach dem Start
 *     prueft EIN Ruhe-Gang im Leerlauf (requestIdleCallback, timeout 1500) das Ausweichen (Pruefrunde 2
 *     Phase B, major: sonst blieb die Blase auf der Befestiger-PDP bei scrollY 0 ueber dem Preisblock);
 *     (c) die Vorschauleiste ist kein Wirt mehr (Punkt 1). Teil 1 (Zustandsklassen) liest nichts und
 *     startet wie bisher bei DOMContentLoaded.
 *  7. RUHE (Feinschliff 3, 03.10.2026). EIN Waechter: passiv auf scroll, touchstart/touchend/touchcancel,
 *     resize und visualViewport (scroll/resize) — er merkt sich nur die Zeit (KEINE Lesung, kein Bild).
 *     Ruhe = kein Finger auf dem Schirm UND RUHE_MS ohne Regung. Dann, einmal je Halt: Ereignis
 *     ap:schwebe-ruhe an document (automotive.js schaltet „Nach oben" mit Hysterese nur jetzt, damit die
 *     Spalte im Wischen weder waechst noch schrumpft), danach im Leerlauf der Ruhe-Gang (Punkt 2; im
 *     Bild-Rueckruf kostete er 34–43 ms Skript und bis 12 ms erzwungenes Layout je Halt).
 *     RUHE_MS 1000 aus der Nachrechnung auf denselben Wischfolgen (scratchpad schwebe3/sim-ruhe.mjs):
 *     Kollektion 360 16 -> 4 Wechsel (Blase 77 % statt 36 % sichtbar), Reifen-PDP Kaufzone 38 -> 14,
 *     Felgen-PDP 12 -> 9; 250 ms waeren auf der Felgen-PDP unruhiger als vorher (25 statt 12), 800 ms auf
 *     Listen noch doppelt so unruhig. Ein Zustandswechsel in Ruhe (Wirt kommt, KI-Platz erscheint oder
 *     waechst, KI-Hinweis auf/zu, die Leiste bewegt die Spalte) prueft sofort neu; im Wischen wartet er
 *     auf die naechste Ruhe.
 *     GEAENDERT Feinschliff 3 FIX (04.10.2026, minor „Nach oben blendet ein und gleitet sofort hinaus"):
 *     im Halt erst ENTSCHEIDEN, dann einschalten. automotive.js setzt auf ap:schwebe-ruhe nur noch
 *     data-ap-soll="an|aus" am Knopf; der Ruhe-Gang rechnet die Stufe „Nach oben" nach data-ap-soll, setzt
 *     ap-schwebe-weicht und meldet DANACH ap:schwebe-entschieden — erst darauf schaltet automotive.js
 *     .is-visible. Unter html.ap-schwebe-weicht bleibt ein frisch eingeschalteter Knopf per Spezifitaet
 *     verborgen und gleitet spaeter mit der Spalte herein (vorher 3 von 9 Einblendungen: Deckkraft 0,27 und
 *     im selben Halt hinaus).
 *  8. STARTPFAD UND LESUNGEN (Phase D Teil 2, P1 „skripte", 08.10.2026; plan.md b1 M1 und M11). Belege M0 8f/8g:
 *     IIFE-Rumpf Kollektion 1.164 / Suche 1.085 / PDP 355 ms (dort landete die erste Layout-Berechnung — Erfolgsmass
 *     TBT/PSI V−K [K30]), pandectesSammeln bis 618 ms, imBild() 132 ms Reflow. Verhalten unveraendert. Jetzt:
 *     (a) beim Auswerten keine Lesung (erst in start()); (b) Banner nur im Bild-Lauf gesammelt, gemessen im Bild-Lauf
 *     oder im ResizeObserver-Rueckruf, Ergebnis gehalten bis zur Meldung (bannerKandidat; b2b: #shopify-pc__banner);
 *     (c) MESSER: Kaesten eines Gangs vom IntersectionObserver, Bedingungen danach neu (gangGilt), ohne ihn gangLesen;
 *     (d) ap:spaet-geladen (P5, [K14]): spaete schwebende Elemente in die Spalte, entschieden nur in Ruhe.
 */

/* ---------------------------------------------------------------- Zustandsklassen (DT-2) */
(function () {
  'use strict';

  var html = document.documentElement;
  if (html.__apZustand) return; // einmal je Seite
  html.__apZustand = true;

  /** EINE Liste: jede offene Lade, jedes Menue, jedes Modal — alles Schwebende geht, solange eine davon offen
   *  ist (Auftrag D; frueher die :has()-Liste in automotive.css). */
  var LADEN = [
    'cart-drawer.active',
    '.mobile-facets__disclosure[open]',
    '#Details-menu-drawer-container[open]',
    'details-modal.header__search details[open]',
    'header-menu details[open]',
    'predictive-search[open]',
    'product-modal[open]',
    // R1 27.09.2026: das Fenster der Judge.me-Lasche haengt direkt an <body>
    'body > .jdgm-modal',
    // Phase B 29.09.2026: der Dialog der Fahrzeugwahl Felgen (natives <dialog>, showModal setzt „open")
    'dialog.ap-fz[open]',
  ];
  /** Die Kaufleiste weicht nur diesen (unveraendert aus section-sticky-atc.css). */
  var LEISTE_WEG = [
    'cart-drawer.active',
    '#Details-menu-drawer-container[open]',
    '.mobile-facets__disclosure[open]',
    'product-modal[open]',
    '.product-media-modal[open]',
    'dialog.ap-fz[open]',
  ];
  var SEL_LADEN = LADEN.join(', ');
  var SEL_LEISTE = LEISTE_WEG.join(', ');
  /** Schliessdauer der Laden (Schublade/Menue/Suche 200 ms = --duration-default, Filterlade 400 ms; Kopf
   *  Punkt 4): so lange bleibt nach dem Schliessen alles Schwebende verborgen (html.ap-lade-zu), dann blendet
   *  es weich ein — sobald auch der Ruhe-Gang entschieden hat, spaetestens nach LADE_ZU_MAX_MS. */
  var LADE_ZU_MS = 300;
  var LADE_ZU_MAX_MS = 1500;
  var zuUhr = 0;
  var zuMaxUhr = 0;
  /** Schliessdauer um? Ruhe-Gang nach dem Schliessen entschieden? Erst beides laesst ap-lade-zu fallen. */
  var zuAbgelaufen = true;
  var zuEntschieden = true;

  function setzen(klasse, an) {
    if (html.classList.contains(klasse) !== an) html.classList.toggle(klasse, an);
  }

  function zuEnde() {
    if (zuUhr) window.clearTimeout(zuUhr);
    if (zuMaxUhr) window.clearTimeout(zuMaxUhr);
    zuUhr = 0;
    zuMaxUhr = 0;
    zuAbgelaufen = true;
    zuEntschieden = true;
    setzen('ap-lade-zu', false);
  }

  function zuPruefen() {
    if (zuAbgelaufen && zuEntschieden && html.classList.contains('ap-lade-zu')) zuEnde();
  }

  function ladeMelden(offen) {
    try {
      document.dispatchEvent(new CustomEvent('ap:lade', { detail: { offen: offen } }));
    } catch (e) {
      /* ohne CustomEvent entscheidet die naechste Ruhe */
    }
  }

  function berechnen() {
    var war = html.classList.contains('ap-lade-offen');
    setzen('ap-lade-offen', !!document.querySelector(SEL_LADEN));
    var offen = html.classList.contains('ap-lade-offen');
    setzen('ap-leiste-weg', !!document.querySelector(SEL_LEISTE));
    setzen('ap-schublade-offen', !!document.querySelector('cart-drawer.active'));
    if (offen === war) return;
    // Ausblenden sofort (CSS am Zustand), Zurueckkommen erst nach der Schliessdauer — im selben Mikrotask,
    // es gibt kein Bild ohne eine der beiden Klassen.
    if (zuUhr) window.clearTimeout(zuUhr);
    if (zuMaxUhr) window.clearTimeout(zuMaxUhr);
    zuUhr = 0;
    zuMaxUhr = 0;
    setzen('ap-lade-zu', !offen);
    if (!offen) {
      // Zurueck erst nach der Schliessdauer UND der Entscheidung des Ruhe-Gangs (Teil 2 meldet sie nach diesem
      // ap:lade) — ohne laufenden Teil 2 nur nach der Schliessdauer.
      zuAbgelaufen = false;
      zuEntschieden = !html.__apSchwebeBereit;
      zuUhr = window.setTimeout(function () {
        zuUhr = 0;
        zuAbgelaufen = true;
        zuPruefen();
      }, LADE_ZU_MS);
      zuMaxUhr = window.setTimeout(zuEnde, LADE_ZU_MAX_MS);
    }
    ladeMelden(offen);
  }

  function istModal(n) {
    return n && n.nodeType === 1 && n.classList && n.classList.contains('jdgm-modal');
  }

  function beobachteSchubladen() {
    var laden = document.querySelectorAll('cart-drawer');
    for (var i = 0; i < laden.length; i++) {
      if (laden[i].__apZustand) continue;
      laden[i].__apZustand = true;
      new MutationObserver(berechnen).observe(laden[i], { attributes: true, attributeFilter: ['class'] });
    }
  }

  function start() {
    // Der Ruhe-Gang (Teil 2) hat nach dem Schliessen einer Lade entschieden: die Spalte darf zurueck.
    document.addEventListener('ap:schwebe-entschieden', function () {
      zuEntschieden = true;
      zuPruefen();
    });
    // „open" traegt jede <details>-Lade, die Kopfsuche (predictive-search) und die Bildansicht (product-modal):
    // EIN Beobachter mit attributeFilter — Klassen- und Stilwechsel des Dokuments kosten ihn nichts.
    new MutationObserver(berechnen).observe(html, { subtree: true, attributes: true, attributeFilter: ['open'] });
    beobachteSchubladen();
    if (document.body) {
      new MutationObserver(function (liste) {
        for (var i = 0; i < liste.length; i++) {
          var r = liste[i];
          for (var a = 0; a < r.addedNodes.length; a++) {
            if (istModal(r.addedNodes[a])) return berechnen();
            if (r.addedNodes[a].nodeName === 'CART-DRAWER') {
              beobachteSchubladen();
              return berechnen();
            }
          }
          for (var e = 0; e < r.removedNodes.length; e++) if (istModal(r.removedNodes[e])) return berechnen();
        }
      }).observe(document.body, { childList: true });
      // Seitenbau, einmal: der grosse Siegel-Block (Kontakt, Ueber uns, Ratgeber, Richtlinien) steht auf der
      // Seite — das Footer-Band nennt Titel und Satz dann nicht ein zweites Mal (ap-siegel.css, R1 si18).
      // Das Footer-Band liegt weit unter dem Falz; frueher body:has(.ap-siegel--seite).
      if (document.querySelector('.ap-siegel--seite')) html.classList.add('ap-hat-siegelseite');
      // Seitenbau, einmal (KI-Telefon-Widget, 01.10.2026): der Wirt der Inbox-Blase steht schon im
      // Server-HTML (App-Einbettung am Ende des <body>, live gemessen). Dann gilt ap-hat-chat ab hier —
      // der KI-Knopf (ap-ki-widget.css) steht damit vom ersten Bild an UEBER der Blase, statt bis zum
      // Leerlauf nach load (Teil 2, wirteSuchen) auf ihrem Platz zu stehen und dann hochzuspringen.
      if (document.querySelector('shopify-chat')) html.classList.add('ap-hat-chat');
    }
    berechnen();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();

/* ---------------------------------------------------------------- Standlinie, Hub, Ruhe, Ausweichen, Aus */
(function () {
  'use strict';

  var html = document.documentElement;
  if (html.hasAttribute('data-ap-standlinie')) return; // einmal je Seite
  if (!('ResizeObserver' in window) || !('MutationObserver' in window) || !window.requestAnimationFrame) return;
  html.setAttribute('data-ap-standlinie', 'live');

  /** Ein unteres Hindernis hoeher als dieser Anteil der Bildhoehe: nichts schwebt mehr darueber. */
  var VERDRAENGT = 0.5;
  /** Um so viel muss das Sichtfeld schrumpfen, damit es als Bildschirmtastatur zaehlt. */
  var TASTATUR_MIN = 150;
  /** Geschuetzte Ziele der SEITE: nie unter einem Schwebenden (Auftrag D). „Zur Kasse" der Schublade und
   *  „Anwenden" der Filterlade stehen nicht hier: solange ihre Lade offen ist, blendet das CSS alle
   *  Schwebenden am Zustand html.ap-lade-offen aus. */
  /* Erweitert nach der Art-Director-Pruefung Feinschliff II R1 (27.09.2026): Auftrag D sagt „nie ueber
   * Preis oder Kaufknopf" — gemessen lagen Blase, „Nach oben" und Laschen aber auf Satzpreisen, „Zusammen
   * in den Warenkorb", Mengen-Chips, Karten-Kaufknoepfen, Warenkorbsummen, dem Finder-Knopf, dem PayPal-/
   * EU-Hinweis am Preis und dem Widerrufsknopf (der steht in der Footer-Gruppe, also OHNE #MainContent). */
  var SCHUTZ = [
    // Kaufkarte der Produktseite
    '#MainContent product-info[id^="MainProduct"] .ap-kauf-preis',
    '#MainContent product-info[id^="MainProduct"] .ap-kauf-preisextras',
    '#MainContent product-info[id^="MainProduct"] .ap-kauf-auswahl',
    '#MainContent product-info[id^="MainProduct"] product-form .product-form__submit',
    '#MainContent product-info[id^="MainProduct"] .shopify-payment-button',
    '#MainContent .ap-quick-qty',
    '#MainContent .ap-setline',
    // R2 (28.09.2026): EU-Label-Knopf der App an der Preiszeile („Label anzeige|n" lag unter der Blase),
    // die Preisentwicklung (Omnibus-Angabe „Niedrigster Preis der letzten 30 Tage", PAngV-Zeile, Trend —
    // die kleinen Zeilen, nicht die ganze Karte: sonst greift IM_BILD_MIN nie) und die Nebenaktionen
    // („Großmenge anfragen" u. a.)
    '#MainContent product-info[id^="MainProduct"] .ttx-eulabel',
    '#MainContent .ttx-ph__now',
    '#MainContent .ttx-ph__stats',
    '#MainContent .ttx-ph__trend',
    '#MainContent .ap-alarm__chip',
    // Satzpreise, Zubehoer, Komplettrad, Vergleich
    '#MainContent .ap-set-pricing__option',
    '#MainContent .ap-set-pricing__total',
    '#MainContent .ap-set-pricing__add',
    // R3 (28.09.2026): die Preiszelle der Satz-Option als EIGENES Ziel — an der grossen Options-Karte
    // scheiterte IM_BILD_MIN, wenn nur ihr unterer Teil im Bild stand („Nach oben" lag auf „€1.159,6[8]",
    // LKW 390); dazu die PAngV-Zeile des Satzes (Blase lag nach 1,6 s Ruhe auf „inkl. 19 % MwSt. …")
    '#MainContent .ap-set-pricing__option-price',
    '#MainContent .ap-set-pricing__mwst',
    '#MainContent .ap-needed-with__totalwrap',
    '#MainContent .ap-needed-with__add-all',
    // R3: Zeilenpreis, PAngV-Zeile und Haken jeder Zubehoerzeile (Felge 360: Blase auf „inkl. MwSt.,
    // versandkostenfrei" der Zentrierring-Zeile, „Nach oben" auf dem Ring-Hinweis)
    '#MainContent .ap-needed-with__price',
    '#MainContent .ap-needed-with__vat',
    '#MainContent .ap-needed-with__check',
    // R3: jede PAngV-Zeile (snippets/ap-mwst-hinweis) und der Klassen-Zeiger der EU-Label-Skala
    // (die Blase verdeckte das „D" der Skala, PKW 390)
    '#MainContent .ap-mwst',
    '#MainContent .ap-eu-label__pointer',
    '#MainContent .ap-eu-label__scale',
    '#MainContent .ap-komplettrad-cta__btn',
    '#MainContent .ap-compare__row--price',
    '#MainContent .ap-compare__row--cta',
    '#MainContent .ap-eu-label__link',
    // Phase B, Pruefrunde 1 (29.09.2026): die neuen Bloecke. Inbox-Chat und „Nach oben" lagen bei
    // 360/390 auf DOT-Preisen, den „+"-Steppern, „Achspaar in den Warenkorb" und „1 Stück in den
    // Warenkorb" (LKW/Motorrad/PKW) — geschuetzt war dort nur die PAngV-Zeile (.ap-mwst).
    // DOT-Jahrgaenge (snippets/ap-dot-jahrgaenge) und die Hinweiszeile unter dem Kaufknopf
    '#MainContent .ap-dotj__preiszelle',
    '#MainContent .ap-dotj__stepper',
    '#MainContent .ap-dotj__opt',
    '#MainContent .ap-dotj__summe-kopf',
    '#MainContent .ap-dotj__vergleich',
    '#MainContent .ap-dotj__kauf',
    '#MainContent .ap-dotj__einzelkauf',
    '#MainContent .ap-dotj__mix-alt',
    '#MainContent .ap-dotj-hinweis',
    // Fahrzeugwahl Felgen (Knopf und Links der Zeile), Zubehoer „Das brauchen Sie zur Felge",
    // „Reifen fuer diese Felge" und der Pack-Hinweis am Einzelstueck
    '#MainContent .ap-fz-zeile__aktionen',
    '#MainContent .ap-nwf__cta',
    '#MainContent .ap-nwf__chip',
    '#MainContent .ap-nwf__preise',
    '#MainContent .ap-kr__chip',
    '#MainContent .ap-kr__saison',
    '#MainContent .ap-packhinweis__kauf',
    '#MainContent .ap-packhinweis__preis',
    // Fahrzeugdaten Felgen (Feld 2.1/2.2, 29.09.2026): Einstieg, Eingaben samt Fehlern und Vorschlag,
    // „Wo steht das?", Pruefen, Rueckfrage, Muster-Beispiele, Status der Karte „Radschrauben" und das
    // Schliessen des Hinweises auf der Warenkorbseite — „Nach oben" lag bei 390 am Rand der Eingabe
    '#MainContent .ap-fzd__auf',
    '#MainContent .ap-fzd__eingabe',
    '#MainContent .ap-fzd__fehler',
    '#MainContent .ap-fzd__wo-kopf',
    '#MainContent .ap-fzd__los',
    '#MainContent .ap-fzd__erg-aktionen',
    '#MainContent .ap-fzd__beispiel',
    '#MainContent .ap-fzd__status-aktionen',
    '#MainContent .ap-fzd-hinweis__zu',
    // Pruefrunde 01.10.2026: der zugeklappte Hinweis auf der Warenkorbseite — sein Knopf „Feld 2.1 und
    // 2.2 angeben" (summary) ist dort die einzige Handlung
    '#MainContent .ap-fzd-hinweis__auf',
    // Finder und Groessensuche (Startseite, Suche, 404, Kollektionen)
    '#MainContent .ttx-finder__btn',
    '#MainContent .ttx-finder select',
    '#MainContent .ttx-finder__f',
    '#MainContent .ap-size-search__submit',
    '#MainContent .ap-size-search__select',
    '#MainContent .ap-prefilter__size-go',
    '#MainContent .ap-prefilter select',
    // Trefferraster (Kollektion, Suche)
    '#MainContent #product-grid .price',
    '#MainContent #product-grid .ap-card-spec__set',
    '#MainContent #product-grid .quick-add__submit',
    '#MainContent #product-grid .ap-cardqty',
    // Karten ausserhalb des Rasters (Bestseller-Karussell der Startseite, Empfehlungen; R2)
    '#MainContent .quick-add__submit',
    '#MainContent .ap-cardqty',
    // R3 (28.09.2026): auch ihre PREISE — „Nach oben" deckte 67 % von „€113,99" im Bestseller-Karussell
    // (Start 390) und „€1.028,99" in „Passend dazu" (LKW 390); geschuetzt war nur #product-grid .price
    '#MainContent .card-information .price',
    '#MainContent .card-wrapper .price',
    '#MainContent .ap-card-price',
    // Datenblatt-Werte stehen rechtsbuendig genau unter der Spalte (R2: „5x130", „1.000 kg", Artikelnummer)
    '#MainContent .ap-spec-table__value',
    // Judge.me: Seitenauswahl, „Bewertung schreiben", Sortierung (R2: „Nach oben" lag auf „>")
    '#MainContent .jm-pagination-controls',
    '#MainContent .jdgm-paginate',
    '#MainContent .jm-review-widget .jm-button--primary',
    '#MainContent .jm-sort-filter__select',
    // Warenkorbseite
    '#MainContent .cart-item .price',
    '#MainContent .cart-item__totals',
    '#MainContent .totals__total-value',
    // R3: die Zeilen der Bestelluebersicht („Artikel (2) €219,98", „Versand kostenlos") — die Blase lag bei
    // 360/390 darauf, geschuetzt war nur die Gesamtsumme
    '#MainContent .cart__summary-value',
    '#MainContent #checkout',
    '#MainContent .cart__dynamic-checkout-buttons',
    '#MainContent .ap-b2b__summary',
    // Formulare und Rechtsknoepfe
    '#MainContent .contact__button .button',
    '#MainContent .ap-stock-alarm button',
    '.newsletter-form__button',
    '.ap-widerruf__open',
    // GEAENDERT Feinschliff 3 FIX (minor): Siegel-Kacheln nur der SEITE und des Footers — die Kacheln im
    // Handy-Menue und in der Schublade deckt ap-lade-offen ab (vorher wich die Spalte hinter dem offenen Menue)
    '#MainContent .ap-siegel__kachel',
    'footer .ap-siegel__kachel',
    '#MainContent .pagination',
    // Zusammenfuehrung 05.10.2026 (gegnerische Pruefung Mobil, minor): Akkordeon-Koepfe der Seite — der Chevron
    // steht rechtsbuendig genau unter der Spalte (Befestiger 360: „Beschreibung", „Montage & Sicherheit")
    '#MainContent details > summary',
    // Zusammenfuehrung Teil 2 (05.10.2026, gegnerische Pruefung App-Seiten, major): die Preise der App-Seiten —
    // heutiges Markup (Groessenliste der Baureihe, Kacheln der Maschinenseite) und Vertrag v2 (ap-price) — und
    // ihre Seitenknoepfe. Im Rueckfall der Vorschau lagen „Nach oben" und der KI-Knopf in der Ruhe auf
    // „158,99 €", „144,99 €", „180,54 €" (Primacy 4) und „327,57 €" (Borbet) bei 360/390. Die Seitenknoepfe
    // einzeln, nicht die ganze Leiste: deren Kasten reicht ueber die volle Breite, die Spalte wiche sonst bei
    // jeder Leiste unter ihr.
    '#MainContent .ttx-sr__price',
    '#MainContent .ttx-ms__tile-price',
    '#MainContent .ap-price',
    '#MainContent .ttx-lp__pager .ap-btn',
    '#MainContent .ttx-ms__page',
  ].join(', ');

  /** KAUF (Feinschliff 3 FIX, Kopf Punkt 2): die Bedienelemente des Kaufs — Teilmenge von SCHUTZ. Ihnen weicht
   *  die Spalte schon beim ersten stabilen Halt (HALT_MS), nicht erst in der Ruhe. */
  var KAUF = [
    '#MainContent product-info[id^="MainProduct"] product-form .product-form__submit',
    '#MainContent product-info[id^="MainProduct"] .shopify-payment-button',
    '#MainContent product-info[id^="MainProduct"] .ap-kauf-auswahl',
    '#MainContent .ap-quick-qty',
    '#MainContent .ap-set-pricing__add',
    '#MainContent .ap-needed-with__add-all',
    '#MainContent .ap-dotj__stepper',
    '#MainContent .ap-dotj__kauf',
    '#MainContent .ap-dotj__einzelkauf',
    '#MainContent .ap-packhinweis__kauf',
    '#MainContent .quick-add__submit',
    '#MainContent .ap-cardqty',
    '#MainContent #checkout',
    '#MainContent .cart__dynamic-checkout-buttons',
    // Zusammenfuehrung 05.10.2026 (gegnerische Pruefung Mobil, minor): der Reifenfinder ist der Haupteinstieg der
    // Startseite — bei y=0 lag die Blase 1,55 s ueber seinem Select (erst RUHE_MS, dann wich sie); jetzt nach HALT_MS
    '#MainContent .ttx-finder select',
    '#MainContent .ttx-finder__btn',
  ].join(', ');

  /** Ausweichen erst ab einer ECHTEN Ueberdeckung (je Achse mindestens so viele px) und nur, wenn das
   *  Ziel mindestens zur Haelfte im Bild steht (R1, sw10: vorher wich die Blase im ganzen ersten
   *  Bildschirm, weil 14 px des Preises am Falz unter ihr lagen). */
  var WEICHEN_MIN = 2;
  var IM_BILD_MIN = 0.5;

  /** RUHE (Kopf Punkt 7): entschieden wird erst, wenn kein Finger aufliegt und so lange keine Regung kam.
   *  Vorher galten 200 ms ohne Treffer + 600 ms Scroll-Ruhe (Listen 1500 ms) — und `scrollend` setzte die
   *  Uhr auf „schon ruhig": die Spalte kam binnen 260 ms nach dem Halt zurueck und ging beim naechsten
   *  Wischer wieder. 1000 ms aus der Nachrechnung (sim-ruhe.mjs), 250 ms waeren unruhiger als vorher. */
  var RUHE_MS = 1000;
  /** HALT (Feinschliff 3 FIX, Kopf Punkt 2): so lange ohne Regung (kein Finger) gilt die Seite als
   *  angehalten — die Spalte weicht dann schon den KAUF-Zielen (nur hinaus). */
  var HALT_MS = 180;
  /** Ein Finger, der laenger als so lange nichts meldet (touchend in einem fremden Rahmen verschluckt),
   *  haelt die Ruhe nicht mehr auf. */
  var FINGER_MAX_MS = 10000;

  /** EIN Bild-Rueckruf fuer Rechnen und Ruhe-Gang (PD-1: hoechstens ein Lauf je Bild). */
  var bildGeplant = false;
  var rechnenFaellig = false;
  var weichenFaellig = false;
  var hindernis = -1;
  var standlinePx = 24;
  var gemeldet = null;
  var sonde = null;
  var bannerElemente = [];
  var beobachtet = typeof WeakSet === 'function' ? new WeakSet() : null;
  /* Startpfad ohne Lesen (P1 M1, Kopf Punkt 8): innerHeight wird erst in start() gelesen, nicht beim Auswerten. */
  var hoeheOhneTastatur = 0;
  // Grundhoehe ohne Tastatur nur nach Groessenwechsel neu lesen (Nachmessung 29.09.): visualViewport.height
  // und innerHeight erzwangen in JEDEM Rechenlauf ohne Eingabefokus eine Stil-Neuberechnung.
  var grundGueltig = false;
  /** Sichthoehe (Kopf Punkt 5 f): gelesen beim Start von Teil 2, nach resize/orientationchange und visualViewport-
   *  resize und je Gang (Stufe 0) — nie im Scroll- oder Beobachter-Pfad, nie beim Auswerten der Datei. */
  var sichtH = 0;

  function jetzt() {
    return window.performance && typeof window.performance.now === 'function' ? window.performance.now() : Date.now();
  }

  function sichtLesen() {
    sichtH = window.innerHeight || sichtH;
  }

  /* Beobachter rechnen SOFORT, nicht erst im naechsten Bild: <sticky-atc> setzt .is-visible selbst in einem
     requestAnimationFrame — der Hub der Spalte wird so im selben Mikrotask geschrieben, und seine
     CSS-Transition startet im selben Stilschritt wie die Blende der Leiste (Kopf Punkt 1). Die Hoehe der
     Kaufleiste kommt NUR aus diesem Rueckruf (nach dem Layout; Kopf Punkt 5 g) — die letzte echte Hoehe
     bleibt, wenn die Leiste [hidden] ist (0 x 0) —, die Banner werden nur neu vermessen, wenn SIE sich
     aendern (DT-1). */
  /* Rechenarten (Phase D Teil 2, P1): BILD = im Bild-Lauf (Banner sammeln und messen), MESSEN = im Rueckruf des
     ResizeObservers (nach dem Layout: messen ja, im Schattenbaum sammeln nein), sonst = Beobachter-Pfad der Leiste
     (mit dem GEHALTENEN Banner-Ergebnis rechnen; Faelliges laeuft im naechsten Bild). */
  var BILD = 'bild';
  var MESSEN = 'messen';
  var groessen = new ResizeObserver(function (eintraege) {
    var banner = !eintraege || !eintraege.length;
    for (var i = 0; eintraege && i < eintraege.length; i++) {
      var ziel = eintraege[i].target;
      if (ziel && (ziel === leisteEl || (ziel.matches && ziel.matches('sticky-atc.ap-sticky-atc')))) {
        var h = boxHoehe(eintraege[i]);
        if (h > 0) leistenHoehe = h;
      } else banner = true;
    }
    if (banner) bannerFaellig = true;
    rechnen(MESSEN);
  });
  var aenderungen = new MutationObserver(function () {
    rechnen();
  });

  /** Hoehe aus dem Eintrag des ResizeObservers (Rahmenkasten), sonst offsetHeight — beides nach dem Layout. */
  function boxHoehe(eintrag) {
    var b = eintrag.borderBoxSize;
    var x = b && (b[0] || b);
    if (x && x.blockSize > 0) return Math.round(x.blockSize);
    return eintrag.target.offsetHeight || 0;
  }

  function zahl(wert, rueckfall) {
    var n = parseFloat(wert);
    return Number.isFinite(n) ? n : rueckfall;
  }

  function einmal(el, fn) {
    if (!el) return;
    if (beobachtet) {
      if (beobachtet.has(el)) return;
      beobachtet.add(el);
    } else if (el.__apSchwebe) {
      return;
    } else {
      el.__apSchwebe = true;
    }
    fn(el);
  }

  /* ------------------------------------------------------------ Hindernisse */

  /** Kaufleiste: ihr ZIELZUSTAND (.is-visible, nicht [hidden]) und ihre Layout-Hoehe — nicht der gerade
   *  animierte Kasten. So gleitet die Spalte GLEICHZEITIG mit der Leiste, statt ihr nachzulaufen.
   *  Hoehe aus dem ResizeObserver (0 = noch keine Messung: dann zaehlt sie, sobald er meldet). */
  var leistenHoehe = 0;
  var leisteEl = null;

  function kaufleiste() {
    if (!leisteEl || !leisteEl.isConnected) leisteEl = document.querySelector('sticky-atc.ap-sticky-atc');
    var el = leisteEl;
    if (!el) return 0;
    einmal(el, function (x) {
      groessen.observe(x);
      aenderungen.observe(x, { attributes: true, attributeFilter: ['class', 'hidden'] });
    });
    if (el.hidden || !el.classList.contains('is-visible')) return 0;
    return leistenHoehe;
  }

  /** Hoehe eines Elements, das am UNTEREN Rand steht (sonst 0 — z. B. der mittige Pandectes-Dialog). */
  function untenVerankert(el) {
    if (!el || !el.isConnected) return 0;
    var cs = window.getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden' || zahl(cs.opacity, 1) === 0) return 0;
    var r = el.getBoundingClientRect();
    var vh = sichtH;
    if (r.width < 1 || r.height < 1 || r.top >= vh) return 0;
    if (r.bottom < vh - 4) return 0;
    return Math.round(vh - r.top);
  }

  /** Hoechstens so viele Kandidaten im Pandectes-Schattenbaum bekommen ein getComputedStyle (DT-1). */
  var PANDECTES_MAX = 12;
  /** Der Schattenbaum hat sich geaendert: vor der naechsten Messung EINMAL neu sammeln (nicht je Aenderung). */
  var bannerNeu = true;
  /** Die gesammelten Banner sind neu zu VERMESSEN (Groesse, Attribute, Sammeln, Groessenwechsel) — gemessen wird im
   *  Bild-Lauf oder im Rueckruf des ResizeObservers, bis dahin gilt das gehaltene Ergebnis (bannerHoehe). */
  var bannerFaellig = true;
  var DIALOG = 'dialog, [role="dialog"], [role="alertdialog"], [aria-modal="true"]';

  /** Banner einmal je Bild (P1 M1): neu gesammelt nur, wenn sich ein KANDIDAT aendern kann (Knoten kommen/gehen,
   *  oberste Ebene, deren Kinder, Dialog, gesammelter Banner); tiefe Aenderungen meldet der ResizeObserver. */
  function bannerKandidat(rec, root) {
    if (!rec || rec.type === 'childList') return true;
    var t = rec.target;
    if (!t || t.nodeType !== 1) return false;
    if (t.parentNode === root || (t.parentNode && t.parentNode.parentNode === root)) return true;
    if (bannerElemente.indexOf(t) !== -1) return true;
    try {
      return !!(t.matches && t.matches(DIALOG));
    } catch (e) {
      return true;
    }
  }

  /** Feste Elemente im Pandectes-Schattenbaum. Gemessen (26.09.): der Banner ist ein Dialog direkt unter
   *  der Schattenwurzel (dialog.notice.box). Deshalb nur die Kandidaten: oberste Ebene, deren Kinder und
   *  jeder Dialog — hoechstens PANDECTES_MAX, statt getComputedStyle fuer bis zu 800 Knoten (DT-1). */
  function pandectesSammeln() {
    bannerNeu = false;
    var host = document.querySelector('pandectes-cmp');
    var root = host && host.shadowRoot;
    var liste = [];
    if (root) {
      einmal(root, function (r) {
        // Der Dialog kommt und geht im Schattenbaum: im naechsten Bild neu sammeln und rechnen — nur, wenn sich
        // ein Kandidat aendern kann (bannerKandidat).
        new MutationObserver(function (aenderungenListe) {
          for (var a = 0; a < aenderungenListe.length; a++) {
            if (!bannerKandidat(aenderungenListe[a], r)) continue;
            bannerNeu = true;
            planen();
            return;
          }
        }).observe(r, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'style', 'open', 'hidden'] });
      });
      var kandidaten = [];
      var nimm = function (el) {
        if (!el || kandidaten.length >= PANDECTES_MAX || kandidaten.indexOf(el) !== -1) return;
        if (/^(STYLE|LINK|SCRIPT|TEMPLATE)$/.test(el.tagName)) return;
        kandidaten.push(el);
      };
      var dialoge = root.querySelectorAll(DIALOG);
      for (var d = 0; d < dialoge.length; d++) nimm(dialoge[d]);
      for (var c = root.firstElementChild; c; c = c.nextElementSibling) {
        nimm(c);
        for (var k = c.firstElementChild; k; k = k.nextElementSibling) nimm(k);
      }
      for (var i = 0; i < kandidaten.length; i++) {
        if (window.getComputedStyle(kandidaten[i]).position === 'fixed') liste.push(kandidaten[i]);
      }
    }
    var shopifyBanner = document.getElementById('shopify-pc__banner');
    if (shopifyBanner) {
      liste.push(shopifyBanner);
      // reifen-b2b (Shopifys eigener Banner, Licht-DOM): Ein- und Ausblenden ueber class/style/hidden aendert die
      // Groesse nicht immer — einmal neu VERMESSEN im naechsten Bild, nicht neu sammeln (P1 Massnahme 1).
      einmal(shopifyBanner, function (x) {
        new MutationObserver(function () {
          bannerFaellig = true;
          planen();
        }).observe(x, { attributes: true, attributeFilter: ['class', 'style', 'hidden'] });
      });
    }
    // Die Vorschauleiste zaehlt nicht mehr (G2, Kopf Punkt 1): es gibt sie live nie.
    liste.forEach(function (el) {
      // groessen beobachtet; die WeakSet von einmal() kennt den Banner schon (MutationObserver oben) — eigener Merker.
      if (el.__apSchwebeGroesse) return;
      el.__apSchwebeGroesse = true;
      groessen.observe(el);
    });
    bannerElemente = liste;
    bannerFaellig = true;
  }

  /* -------------------------------------------------------------- Eichen */

  /** Die Sonde (display:block gegen Dawns div:empty-Regel): sie traegt die Token der Spalte, der Browser
   *  loest sie in px auf (die Token stehen in rem — parseFloat auf den Tokentext ergab 1,2 statt 12 px, R1
   *  sw1). Gelesen wird NUR beim Eichen: beim Start und nach einem Breitenwechsel/Drehen. */
  function sondeHolen() {
    if (!sonde || !sonde.isConnected) {
      sonde = document.createElement('div');
      sonde.setAttribute('aria-hidden', 'true');
      sonde.setAttribute('data-ap-schwebe-sonde', '');
      sonde.style.cssText =
        'display:block;position:fixed;left:0;width:0;height:0;visibility:hidden;pointer-events:none;' +
        'bottom:var(--ap-float-floor, 24px);padding:var(--ap-float-stack, 12px) var(--ap-float-edge, 8px) var(--ap-float-gap, 16px) 0;' +
        'margin:0 0 var(--ap-float-rest, 24px) 0;box-sizing:content-box;max-width:var(--ap-float-size, 44px)';
      document.body.appendChild(sonde);
    }
    return sonde;
  }

  /** Rand, Stapelabstand und Groesse der rechten Spalte, Ruhelage und Luft der Standlinie (px) — GEEICHT,
   *  nie im Scroll-Pfad. Dauer und Kurve des Hubs stehen seit Feinschliff 3 FIX im CSS (transition). */
  var spalteRand = 8;
  var spalteAbstand = 12;
  var ruhePx = 24;
  var luftPx = 16;
  var groessePx = 44;
  var geeicht = false;

  function eichen() {
    var cs = window.getComputedStyle(sondeHolen());
    spalteRand = zahl(cs.paddingRight, 8);
    spalteAbstand = zahl(cs.paddingTop, 12);
    ruhePx = zahl(cs.marginBottom, 24);
    luftPx = zahl(cs.paddingBottom, 16);
    groessePx = zahl(cs.maxWidth, 44);
    geeicht = true;
  }

  function standlinie() {
    if (!geeicht) eichen();
    return Math.max(ruhePx, Math.max(hindernis, 0) + luftPx);
  }

  /* -------------------------------------------------------------- EIN Hub (Kopf Punkt 1) */

  /** Senkrechter Versatz der Spalte in px (Ruhelage minus Standlinie, <= 0) — der ZIELWERT; das Gleiten
   *  macht die CSS-Transition auf translate (Compositor, Kurve und Dauer der Kaufleiste). */
  var hubWert = 0;
  /** Die drei Elemente der rechten Spalte — die einzigen, an die der Hub geschrieben wird. */
  var spalteEl = { chat: null, ki: null, hoch: null };

  function spalteHolen() {
    spalteEl.chat = document.querySelector('shopify-chat');
    spalteEl.ki = document.querySelector('.ap-ki');
    spalteEl.hoch = document.querySelector('.ap-to-top');
  }

  function rund(n) {
    return Math.round(n * 100) / 100;
  }

  /** Schreibt den Zielwert EINMAL an Wirt der Blase, KI-Platz und „Nach oben" — Inline-Werte an drei kleinen
   *  Elementen, nichts an <html>, nichts gelesen. Das Gleiten startet im naechsten Stilschritt, fuer alle
   *  drei und die Leiste zugleich. */
  function hubSchreiben(y) {
    hubWert = rund(y);
    var px = hubWert + 'px';
    if (spalteEl.ki) spalteEl.ki.style.setProperty('--ap-schwebe-hub', px);
    if (spalteEl.hoch) spalteEl.hoch.style.setProperty('--ap-schwebe-hub', px);
    if (spalteEl.chat) spalteEl.chat.style.setProperty('--ap-schwebe-hub', px);
  }

  /** Offenes Chatfenster (Kopf Punkt 1): shopify-chat[open] steht ohne translate (CSS). Geht es zu, stuende
   *  die Blase sonst in der Ruhelage und glitte erst dann auf ihren Hub — die Transition ist dafuer zwei
   *  Bilder lang aus (Inline-Wert, schlaegt das Stylesheet). */
  function chatBeobachten(host) {
    if (!host || host.__apChatZu) return;
    host.__apChatZu = true;
    var offen = host.hasAttribute('open');
    new MutationObserver(function () {
      var jetztOffen = host.hasAttribute('open');
      if (jetztOffen === offen) return;
      offen = jetztOffen;
      if (offen) return;
      host.style.setProperty('transition', 'none');
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          host.style.removeProperty('transition');
        });
      });
    }).observe(host, { attributes: true, attributeFilter: ['open'] });
  }

  /** Hoehe des hoechsten unten verankerten Banners (px) — GEHALTEN, bis bannerFaellig neu vermessen laesst (RO der
   *  Banner, Sammeln, Groessenwechsel, Attribute des Shopify-Banners). */
  var bannerHoehe = 0;

  /** messen = Banner duerfen jetzt vermessen werden (Bild-Lauf oder Rueckruf des ResizeObservers nach dem Layout);
   *  sonst rechnet der Beobachter-Pfad mit der gehaltenen Hoehe (rechnen() plant das Messen ins naechste Bild). */
  function hindernisRechnen(messen) {
    var h = kaufleiste();
    if (bannerFaellig && messen) {
      bannerFaellig = false;
      bannerHoehe = 0;
      for (var i = 0; i < bannerElemente.length; i++) bannerHoehe = Math.max(bannerHoehe, untenVerankert(bannerElemente[i]));
    }
    h = Math.max(h, bannerHoehe);
    var verdraengt = h > sichtH * VERDRAENGT;
    if (verdraengt) h = 0; // nichts schwebt ueber einem halben Bildschirm — es geht ganz weg (unten)
    hindernis = h;
    standlinePx = standlinie();
    var ziel = rund(ruhePx - standlinePx);
    if (ziel !== hubWert) {
      hubSchreiben(ziel);
      // In Ruhe (Groessenwechsel ohne Scrollen) steht die Spalte jetzt ueber anderem Inhalt: einmal neu
      // entscheiden. Die Zonen rechnen mit der ZIEL-Standlinie, nicht mit dem gerade gleitenden Kasten.
      if (ruhig()) pruefenWennRuhig();
    }
    return verdraengt;
  }

  /** Ist eine Bildschirmtastatur offen? Nur wenn ein Eingabefeld DER SEITE den Fokus hat (ein Feld im
   *  Chatfenster meldet sich als shopify-chat und laesst die Blase stehen) UND das Sichtfeld um mindestens
   *  TASTATUR_MIN kleiner ist als zuletzt ohne Fokus. */
  function editierbarImFokus() {
    var ae = document.activeElement;
    return (
      !!ae && ae !== document.body && (ae.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(ae.tagName)) &&
      !(ae.type && /^(button|submit|reset|checkbox|radio|range|color|file|image|hidden)$/.test(ae.type))
    );
  }

  function tastaturOffen() {
    var vv = window.visualViewport;
    if (!editierbarImFokus()) {
      if (!grundGueltig) {
        hoeheOhneTastatur = Math.max(window.innerHeight, vv ? Math.round(vv.height * (vv.scale || 1)) : 0);
        grundGueltig = true;
      }
      return false;
    }
    var sicht = vv ? vv.height * (vv.scale || 1) : window.innerHeight;
    return hoeheOhneTastatur - sicht >= TASTATUR_MIN;
  }

  /* --------------------------------------------------------------- Ruhe und Halt (Kopf Punkte 2 und 7) */

  var finger = 0;
  var letzteRegung = -Infinity;
  var ruheUhr = 0;
  var haltUhr = 0;
  var entschieden = false;
  /** Letztes SCROLL-Ereignis (Fenster oder visualViewport) — anders als letzteRegung ohne Beruehrungen: ein Tipp
   *  bewegt die Seite nicht (Schliess-Gang, Kopf Punkt 4). */
  var letzterScroll = -Infinity;

  function fingerHaelt() {
    return finger > 0 && jetzt() - letzteRegung < FINGER_MAX_MS;
  }

  function ruhig() {
    if (fingerHaelt()) return false;
    return jetzt() - letzteRegung >= RUHE_MS;
  }

  /** Jede Regung des Bildes: nur die Zeit merken und die Uhren stellen — keine Lesung, kein Bild. */
  function regung() {
    letzteRegung = jetzt();
    entschieden = false;
    ruheWecken();
    haltWecken();
  }

  function ruheWecken() {
    if (ruheUhr) return;
    // Liegt ein Finger auf, meldet sich das Abheben selbst (fingerAb stellt die Uhr neu); bis dahin nur
    // der Rueckfall nach FINGER_MAX_MS.
    var vergangen = jetzt() - letzteRegung;
    var warten = (finger > 0 ? FINGER_MAX_MS : RUHE_MS) - vergangen;
    ruheUhr = window.setTimeout(ruheErreicht, Math.max(0, warten) + 20);
  }

  /** Der HALT-Waechter (Kopf Punkt 2): EINE Uhr, die nur nachgestellt wird, wenn sie abgelaufen ist und noch
   *  keine HALT_MS Stille herrschen — keine Uhr je Scroll-Ereignis. */
  function haltWecken() {
    if (haltUhr) return;
    var warten = HALT_MS - (jetzt() - letzteRegung);
    haltUhr = window.setTimeout(haltErreicht, Math.max(0, warten) + 10);
  }

  function haltErreicht() {
    haltUhr = 0;
    // Nur mit der Zielliste des IntersectionObservers (Kopf Punkt 5 h): ohne sie kostete jeder Halt die volle
    // SCHUTZ-Abfrage — dann entscheidet wie bisher allein die Ruhe.
    if (!ioBereit) return;
    if (fingerHaelt()) return; // das Abheben ist eine Regung und stellt die Uhr neu
    var still = jetzt() - letzteRegung;
    if (still < HALT_MS) {
      haltWecken();
      return;
    }
    if (still >= RUHE_MS) return; // die Ruhe entscheidet ohnehin
    weichenPruefen({ nurHinaus: true });
  }

  function ruheErreicht() {
    if (ruheUhr) window.clearTimeout(ruheUhr);
    ruheUhr = 0;
    if (!ruhig()) {
      ruheWecken();
      return;
    }
    if (entschieden) return;
    entschieden = true;
    // „Nach oben" (automotive.js) merkt sich zuerst seinen Soll-Zustand (data-ap-soll) — der Ruhe-Gang rechnet
    // die Spalte damit und meldet danach ap:schwebe-entschieden (Kopf Punkt 7).
    melden('ap:schwebe-ruhe');
    weichenPlanen();
  }

  /** Ein Zustand hat sich geaendert (Wirt, KI-Platz, Hinweis, Hub in Ruhe, Lade zu): in Ruhe sofort neu
   *  entscheiden, im Wischen in der naechsten Ruhe. */
  function pruefenWennRuhig() {
    entschieden = false;
    if (ruhig()) ruheErreicht();
    else ruheWecken();
  }

  function fingerAuf(e) {
    finger = e && e.touches ? e.touches.length : 1;
    gleitenBeenden();
    regung();
  }

  function fingerAb(e) {
    finger = e && e.touches ? e.touches.length : 0;
    // Die Uhr wartete auf das Abheben (FINGER_MAX_MS): ab jetzt wieder RUHE_MS.
    if (ruheUhr) window.clearTimeout(ruheUhr);
    ruheUhr = 0;
    regung();
  }

  function melden(name) {
    try {
      document.dispatchEvent(new CustomEvent(name));
    } catch (e) {
      /* ohne CustomEvent: „Nach oben" schaltet wie ohne Schwebe-System */
    }
  }

  /* --------------------------------------------------------------- Ziele im Bild (Kopf Punkt 5 h) */

  /** Die SCHUTZ-Ziele, die gerade im Bild stehen — gefuehrt von EINEM IntersectionObserver (keine Lesung). */
  var imBildMenge = typeof Set === 'function' ? new Set() : null;
  var schutzIo = null;
  var ioBereit = false;
  var gesammelt = [];
  var sammelLauf = 0;

  function passt(el, sel) {
    try {
      return !!el && typeof el.matches === 'function' && el.matches(sel);
    } catch (e) {
      return false;
    }
  }

  /** Sammelt die SCHUTZ-Ziele EINMAL (im Leerlauf) und beobachtet neue; nicht mehr vorhandene fallen heraus. */
  function schutzSammeln() {
    if (!imBildMenge || typeof window.IntersectionObserver !== 'function') return;
    if (!schutzIo) {
      schutzIo = new window.IntersectionObserver(function (eintraege) {
        for (var i = 0; i < eintraege.length; i++) {
          if (eintraege[i].isIntersecting) imBildMenge.add(eintraege[i].target);
          else imBildMenge.delete(eintraege[i].target);
        }
        if (!ioBereit) {
          ioBereit = true;
          pruefenWennRuhig();
        }
      }, { root: null, rootMargin: '0px', threshold: 0 });
    }
    sammelLauf++;
    var liste = document.querySelectorAll(SCHUTZ);
    var neu = [];
    for (var i = 0; i < liste.length; i++) {
      var el = liste[i];
      neu.push(el);
      el.__apSchutzLauf = sammelLauf;
      if (el.__apSchutz) continue;
      el.__apSchutz = true;
      el.__apKauf = passt(el, KAUF);
      schutzIo.observe(el);
    }
    for (var j = 0; j < gesammelt.length; j++) {
      var alt = gesammelt[j];
      if (alt.__apSchutzLauf === sammelLauf) continue;
      schutzIo.unobserve(alt);
      imBildMenge.delete(alt);
      alt.__apSchutz = false;
    }
    gesammelt = neu;
  }

  /** DOM-Aenderungen im Hauptinhalt (Abschnitte, Empfehlungen, Judge.me): entprellt neu sammeln, im Leerlauf. */
  var sammelUhr = 0;
  function sammelnPlanen() {
    if (sammelUhr || !schutzIo) return;
    sammelUhr = window.setTimeout(function () {
      sammelUhr = 0;
      if (typeof window.requestIdleCallback === 'function') window.requestIdleCallback(schutzSammeln, { timeout: 1500 });
      else schutzSammeln();
    }, 500);
  }

  /** Die Ziele fuer den Ruhe-Gang: die im Bild (IntersectionObserver) — vor seiner ersten Meldung bzw. ohne
   *  ihn die volle Abfrage (Rueckfall). */
  function zieleImBild() {
    if (ioBereit && imBildMenge) {
      var a = [];
      imBildMenge.forEach(function (el) {
        if (el.isConnected) a.push(el);
      });
      return a;
    }
    return document.querySelectorAll(SCHUTZ);
  }

  function istKauf(el) {
    if (el.__apKauf === undefined) el.__apKauf = passt(el, KAUF);
    return el.__apKauf;
  }

  /* --------------------------------------------------------------- Ausweichen (Halt und Ruhe) */

  function chatKnopf() {
    var host = spalteEl.chat || document.querySelector('shopify-chat');
    var root = host && host.shadowRoot;
    return root ? root.querySelector('[part~="activator"]') : null;
  }

  /* ---------------------------------------------------------- Messer (Phase D Teil 2, P1, Kopf Punkt 8) */

  /** MESSER (P1 M1, Kopf Punkt 8): die Kaesten eines Gangs meldet der Browser (IntersectionObserver: boundingClientRect
   *  und rootBounds, nach dem Layout des naechsten Bildes) — kein erzwungenes Layout (M0: imBild 132 ms). Bleibt die
   *  Meldung MESSER_BILDER Bilder aus oder fehlt der Beobachter: fertig(null), der Gang liest selbst. */
  var MESSER_BILDER = 2;
  /** NACHBESSERUNG N1 (M1-d, 10.10.2026): unter Last kam die Meldung des Beobachters auf der PDP spaeter als
   *  MESSER_BILDER Bilder (die Meldung ist eine eigene Aufgabe NACH dem Bild, das sie berechnet) — dann las der Gang
   *  alle Kaesten selbst: erzwungenes Layout, Lighthouse M1-d 99/138 ms in kasten() (PD-1/PD-10). Jetzt holt der
   *  Messer nach Ablauf erst die schon BERECHNETEN Meldungen ab (takeRecords, ohne Layout) und fragt die fehlenden
   *  Ziele neu an — hoechstens MESSER_RUNDEN Runden; selbst gelesen wird nur noch ohne einen echten Beobachter
   *  (kein takeRecords: alte Browser, Attrappen) bzw. nach der letzten Runde. */
  var MESSER_RUNDEN = 4;

  function kaestenHolen(els, fertig) {
    var IO = window.IntersectionObserver;
    if (typeof IO !== 'function' || typeof Map !== 'function') {
      fertig(null);
      return;
    }
    var ziele = [];
    for (var i = 0; i < els.length; i++) {
      if (els[i] && els[i].isConnected && ziele.indexOf(els[i]) === -1) ziele.push(els[i]);
    }
    var kaesten = new Map();
    var sicht = null;
    var offen = ziele.length;
    var erledigt = false;
    var io = null;
    function ende(ergebnis) {
      if (erledigt) return;
      erledigt = true;
      if (io) io.disconnect();
      fertig(ergebnis);
    }
    function aufnehmen(eintraege) {
      for (var e = 0; e < eintraege.length; e++) {
        var x = eintraege[e];
        if (!x || !x.boundingClientRect || kaesten.has(x.target) || ziele.indexOf(x.target) === -1) continue;
        kaesten.set(x.target, x.boundingClientRect);
        if (x.rootBounds && x.rootBounds.height > 0) sicht = x.rootBounds;
        offen--;
      }
      if (offen <= 0 && sicht) ende({ kaesten: kaesten, sicht: sicht });
    }
    try {
      io = new IO(aufnehmen);
      for (var z = 0; z < ziele.length; z++) io.observe(ziele[z]);
    } catch (err) {
      ende(null);
      return;
    }
    // Ohne ein einziges Ziel gibt es keine Meldung und kein Sichtfeld: dann liest der Gang selbst (Rueckfall).
    if (!ziele.length) {
      ende(null);
      return;
    }
    var echt = typeof io.takeRecords === 'function';
    var runde = 1;
    var bilder = 0;
    var warten = function () {
      window.requestAnimationFrame(function () {
        if (erledigt) return;
        if (++bilder < MESSER_BILDER) {
          warten();
          return;
        }
        if (echt) {
          // Schon berechnete, noch nicht zugestellte Meldungen abholen (kein Layout).
          try {
            aufnehmen(io.takeRecords());
          } catch (err) {
            echt = false;
          }
          if (erledigt) return;
        }
        if (echt && runde < MESSER_RUNDEN) {
          runde++;
          bilder = 0;
          // Fehlende Ziele neu anfragen (Erstmeldung nach dem naechsten Layout); entfernte zaehlen als erledigt
          // (imBild prueft isConnected ohne Lesung).
          for (var i = 0; i < ziele.length; i++) {
            if (kaesten.has(ziele[i])) continue;
            if (!ziele[i].isConnected) {
              kaesten.set(ziele[i], { top: 0, bottom: 0, left: 0, right: 0, width: 0, height: 0 });
              offen--;
              continue;
            }
            io.unobserve(ziele[i]);
            io.observe(ziele[i]);
          }
          if (offen <= 0 && sicht) {
            ende({ kaesten: kaesten, sicht: sicht });
            return;
          }
          warten();
          return;
        }
        ende(null);
      });
    };
    warten();
  }

  /** Kasten eines Elements: aus dem Messer (k), sonst selbst gelesen (Rueckfall). */
  function kasten(el, k) {
    if (k && k.kaesten.has(el)) return k.kaesten.get(el);
    return el.getBoundingClientRect();
  }

  /** Kasten eines Ziels, wenn es im Bild steht — OHNE getComputedStyle (das kommt erst, wenn es eine Zone
   *  wirklich schneidet: DT-1). */
  function imBild(el, k) {
    if (!el || !el.isConnected) return null;
    var r = kasten(el, k);
    if (r.width < 1 || r.height < 1) return null;
    if (r.bottom <= 0 || r.top >= sichtH) return null;
    return r;
  }

  function unsichtbar(el) {
    return window.getComputedStyle(el).visibility === 'hidden';
  }

  function schneidet(a, b) {
    return a && b && a.left < b.right && b.left < a.right && a.top < b.bottom && b.top < a.bottom;
  }

  /** Echte Ueberdeckung eines Ziels: je Achse mindestens WEICHEN_MIN px, und das Ziel steht mindestens
   *  zur Haelfte (seiner Hoehe, hoechstens der Bildhoehe) im Bild. */
  function deckt(zone, r) {
    if (!zone || !r) return false;
    var w = Math.min(zone.right, r.right) - Math.max(zone.left, r.left);
    var h = Math.min(zone.bottom, r.bottom) - Math.max(zone.top, r.top);
    if (w < WEICHEN_MIN || h < WEICHEN_MIN) return false;
    var vh = sichtH;
    var sicht = Math.min(r.bottom, vh) - Math.max(r.top, 0);
    return sicht >= Math.min(r.height, vh) * IM_BILD_MIN;
  }

  function decktEine(zonen, r) {
    for (var i = 0; i < zonen.length; i++) if (deckt(zonen[i], r)) return true;
    return false;
  }

  /** Steht „Nach oben" in der Spalte? Im Ruhe-Gang zaehlt der Soll-Zustand aus automotive.js (data-ap-soll,
   *  Kopf Punkt 7), im Halt der jetzige (.is-visible); im Gespraech nie (die Pille liegt darueber). */
  function hochSteht(hoch, nachSoll) {
    if (!hoch || hoch.hidden || html.classList.contains('ap-ki-aktiv')) return false;
    var soll = nachSoll ? hoch.getAttribute('data-ap-soll') : null;
    if (soll === 'an') return true;
    if (soll === 'aus') return false;
    return hoch.classList.contains('is-visible');
  }

  /** Die rechte Spalte, GERECHNET aus Standlinie und geeichter Groesse — gestapelt wie im CSS (die Blase
   *  belegt ihre Stufe, sobald ihr Wirt da ist = html.ap-hat-chat; KI-Platz, im Gespraech in Pillengroesse;
   *  „Nach oben" siehe hochSteht). Nie aus ihren Kaesten: sie gleiten gerade oder sind ausgewichen. Die Stufe
   *  der Blase ZAEHLT erst, wenn ihr Knopf im Schattenbaum steht (sonst weichen KI und „Nach oben" einer
   *  Blase, die es noch nicht gibt). `zonen` = die zaehlenden Stufen von unten nach oben, `spalte` = ihre
   *  Huelle. */
  function spaltenTeile(knopf, nachSoll, breiteSicht) {
    var vw = breiteSicht || html.clientWidth || window.innerWidth;
    var unten = sichtH - standlinePx;
    var stufen = [];
    var breite = 0;
    function stapeln(w, h, zaehlt) {
      var u = stufen.length ? stufen[stufen.length - 1].top - spalteAbstand : unten;
      stufen.push({ top: u - h, bottom: u, zaehlt: zaehlt });
      if (zaehlt) breite = Math.max(breite, w);
    }
    if (html.classList.contains('ap-hat-chat') && spalteEl.chat) stapeln(groessePx, groessePx, !!knopf);
    var ki = spalteEl.ki;
    if (ki && !ki.hidden) {
      // Im Gespraech hat der Platz die Groesse der Pille (Inline-Werte aus ap-ki-widget.js, ohne Lesung).
      var kw = parseFloat(ki.style.width);
      var kh = parseFloat(ki.style.height);
      stapeln(kw > 0 ? kw : groessePx, kh > 0 ? kh : groessePx, true);
    }
    if (hochSteht(spalteEl.hoch, nachSoll)) stapeln(groessePx, groessePx, true);
    if (!breite) return null;
    var links = vw - spalteRand - breite;
    var zonen = [];
    var oben = unten;
    for (var i = 0; i < stufen.length; i++) {
      if (!stufen[i].zaehlt) continue;
      zonen.push({ left: links, right: vw - spalteRand, top: stufen[i].top, bottom: stufen[i].bottom });
      oben = Math.min(oben, stufen[i].top);
    }
    return { spalte: { left: links, right: vw - spalteRand, top: oben, bottom: zonen[0].bottom }, zonen: zonen };
  }

  var LASCHEN = '.ap-call-tab, .jdgm-revs-tab-btn';

  /** Senkrechte Spanne der Laschen an der rechten Kante (waagerecht verschiebt sie nur das Einklappen). */
  function laschenZone() {
    return laschenZoneAus(null, null, 0);
  }

  /** Dasselbe mit den Elementen und Kaesten aus dem Gang (Messer, Kopf Punkt 8); ohne sie selbst gesucht und
   *  gelesen (Rueckfall). */
  function laschenZoneAus(els, k, breiteSicht) {
    var vw = breiteSicht || html.clientWidth || window.innerWidth;
    var oben = Infinity;
    var unten = -Infinity;
    var breite = 0;
    if (!els) els = document.querySelectorAll(LASCHEN);
    for (var i = 0; i < els.length; i++) {
      var r = kasten(els[i], k);
      if (r.height < 2 || r.width < 2) continue;
      oben = Math.min(oben, r.top);
      unten = Math.max(unten, r.bottom);
      breite = Math.max(breite, r.width);
    }
    if (!breite) return null;
    return { left: vw - breite, right: vw, top: oben, bottom: unten };
  }

  /** Der offene Hinweis des KI-Widgets (Rueckfall oder Gespraechsfehler, assets/ap-ki-widget.css). Unter
   *  600 px steht er im Gespraechsfehler UEBER der Pille — nach dem Hochscrollen stehen dort die Laschen
   *  (Nachmessung 03.10.2026): sie weichen ihm wie der Spalte. Verborgen oder ohne Groesse: keine Zone. */
  function hinweisZone() {
    var h = document.querySelector('.ap-ki__hinweis');
    if (!h || h.hidden) return null;
    var r = h.getBoundingClientRect();
    if (r.width < 2 || r.height < 2) return null;
    return { left: r.left, right: r.right, top: r.top, bottom: r.bottom };
  }

  /** Dasselbe mit dem Kasten aus dem Messer (Kopf Punkt 8): das Element waehlt der Gang ohne Lesung. */
  function hinweisElement() {
    var h = document.querySelector('.ap-ki__hinweis');
    return !h || h.hidden ? null : h;
  }

  function hinweisZoneAus(h, k) {
    if (!h || h.hidden) return null;
    var r = kasten(h, k);
    if (r.width < 2 || r.height < 2) return null;
    return { left: r.left, right: r.right, top: r.top, bottom: r.bottom };
  }

  /** GLEIT-ENDE BEIM FINGERAUFSETZEN (Zusammenfuehrung 05.10.2026, gegnerische Pruefung Mobil, minor): fiel die
   *  Halt-/Ruhe-Entscheidung kurz vor dem naechsten Wisch, lief das Hinausgleiten (--ap-float-glide, 220 ms) unter dem
   *  Finger weiter (35–72 px seitlich in 4 von 13 Wischlaeufen). Setzt ein Finger auf, solange die Spalte seit dem
   *  Ausweichen noch keine GLEIT_MS steht, schaltet html.ap-schwebe-sofort ihre Transition fuer zwei Bilder ab — die
   *  Endlage (draussen, verborgen) steht sofort. Zurueck gleitet sie nicht mehr (Endlage + Deckkraft, CSS). */
  var GLEIT_MS = 260;
  var weichtSeit = -Infinity;

  function klasse(name, an) {
    if (html.classList.contains(name) === an) return;
    html.classList.toggle(name, an);
    if (an && name === 'ap-schwebe-weicht') weichtSeit = jetzt();
  }

  function gleitenBeenden() {
    if (!html.classList.contains('ap-schwebe-weicht') || jetzt() - weichtSeit >= GLEIT_MS) return;
    if (html.classList.contains('ap-schwebe-sofort')) return;
    html.classList.add('ap-schwebe-sofort');
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        html.classList.remove('ap-schwebe-sofort');
      });
    });
  }

  /** Der Ruhe-Gang laeuft im LEERLAUF (Abnahme Feinschliff 3: im Bild-Rueckruf kostete er auf der
   *  Reifen-PDP 34–43 ms Skript und bis 12 ms erzwungenes Stil/Layout je Halt — im Leerlauf nach dem
   *  gemalten Bild ist das Layout sauber, und kein Bild wartet auf ihn). Frist 500 ms (nach dem Schliessen
   *  einer Lade kuerzer, damit vor dem Einblenden entschieden ist); ohne requestIdleCallback im naechsten
   *  Bild. */
  var leerlaufGeplant = false;

  function weichenPlanen(frist) {
    if (typeof window.requestIdleCallback === 'function') {
      if (leerlaufGeplant) return;
      leerlaufGeplant = true;
      window.requestIdleCallback(function () {
        leerlaufGeplant = false;
        weichenPruefen();
      }, { timeout: frist || 500 });
      return;
    }
    weichenFaellig = true;
    bildPlanen();
  }

  /** Steht der Wirt der Blase, ihr Knopf im Schattenbaum aber noch nicht (die App rendert spaeter), wird
   *  so oft im Abstand KNOPF_WARTEN_MS neu entschieden (Pruefrunde 2 Phase B). */
  var KNOPF_VERSUCHE = 10;
  var KNOPF_WARTEN_MS = 400;
  var knopfVersuche = 0;

  /** Darf der Gang (noch) entscheiden? Vor der Anfrage UND nach der Meldung des Messers (ein Bild spaeter) gefragt:
   *  offene Lade/Menue oder alles aus (Tastatur) — nichts entscheiden, das Schliessen meldet sich (ap:lade); der
   *  Halt-Gang nur, solange die Spalte nicht schon weicht und seit HALT_MS keine Regung kam (sonst entscheidet die
   *  naechste Halt-Uhr); der Ruhe-Gang nur in Ruhe (sonst die naechste Ruhe); der Schliess-Gang ohne RUHE_MS. */
  function gangGilt(opt, nachMessung) {
    var nurHinaus = !!(opt && opt.nurHinaus);
    // Schliess-Gang (Kopf Punkt 4): die Seite steht seit HALT_MS, kein Finger — entschieden wird ohne RUHE_MS.
    var schliessen = !!(opt && opt.schliessen);
    if (html.classList.contains('ap-lade-offen') || html.classList.contains('ap-schwebe-aus')) {
      if (!nurHinaus) entschieden = false;
      return false;
    }
    if (nurHinaus) {
      if (html.classList.contains('ap-schwebe-weicht')) return false;
      if (nachMessung && (fingerHaelt() || jetzt() - letzteRegung < HALT_MS)) return false;
    } else if (!schliessen && !ruhig()) {
      entschieden = false;
      ruheWecken();
      return false;
    }
    return true;
  }

  /** DER RUHE-GANG: einmal je Ruhe (und nach einem Zustandswechsel in Ruhe) — Spalte UND Laschen, hinaus
   *  und zurueck. Mit { nurHinaus: true } der HALT-Gang (Kopf Punkt 2): nur die KAUF-Ziele, nur hinaus.
   *  Nur hier wird gelesen — die Ziele im Bild, ihre Kaesten, die Laschen. Mit IntersectionObserver liest der
   *  BROWSER (Messer, Kopf Punkt 8): der Gang waehlt hier nur die Elemente (ohne Lesung) und entscheidet in
   *  gangAuswerten, sobald die Kaesten gemeldet sind. Ohne IntersectionObserver unveraendert (gangLesen). */
  function weichenPruefen(opt) {
    var nurHinaus = !!(opt && opt.nurHinaus);
    if (!nurHinaus) weichenFaellig = false;
    if (!gangGilt(opt, false)) return;
    if (typeof window.IntersectionObserver !== 'function') {
      gangLesen(opt);
      return;
    }
    var knopf = knopfPruefen(nurHinaus);
    var laschenEls = [];
    var hinweis = null;
    if (!nurHinaus) {
      var gefunden = document.querySelectorAll(LASCHEN);
      for (var l = 0; l < gefunden.length; l++) laschenEls.push(gefunden[l]);
      hinweis = hinweisElement();
    }
    var ziele = [];
    if (spalteDa(knopf, !nurHinaus) || laschenEls.length) {
      var liste = zieleImBild();
      for (var i = 0; i < liste.length; i++) {
        if (nurHinaus && !istKauf(liste[i])) continue;
        ziele.push(liste[i]);
      }
    }
    var messen = ziele.concat(laschenEls);
    if (hinweis) messen.push(hinweis);
    // Nichts zu messen (kein Ziel im Bild, keine Lasche, kein Hinweis): nichts kann weichen — wie gangLesen, ohne Lesung.
    if (!messen.length) {
      entscheidungSetzen(nurHinaus, false, false);
      return;
    }
    kaestenHolen(messen, function (k) {
      // Zwischen Anfrage und Meldung liegt mindestens ein Bild: Regung, Lade, Tastatur — neu fragen (auch im
      // Rueckfall ohne Meldung, der zwei Bilder spaeter selbst liest).
      if (!gangGilt(opt, true)) return;
      gangAuswerten(opt, knopf, ziele, laschenEls, hinweis, k);
    });
  }

  /** Steht der Wirt der Blase, ihr Knopf aber noch nicht: in KNOPF_WARTEN_MS neu entscheiden (Pruefrunde 2 Phase B). */
  function knopfPruefen(nurHinaus) {
    var knopf = chatKnopf();
    if (!nurHinaus && spalteEl.chat && !knopf && knopfVersuche < KNOPF_VERSUCHE) {
      knopfVersuche++;
      window.setTimeout(pruefenWennRuhig, KNOPF_WARTEN_MS);
    }
    return knopf;
  }

  /** Gibt es eine zaehlende Stufe der Spalte? Dieselbe Regel wie spaltenTeile (breite > 0), ohne Lesung. */
  function spalteDa(knopf, nachSoll) {
    if (html.classList.contains('ap-hat-chat') && spalteEl.chat && knopf) return true;
    if (spalteEl.ki && !spalteEl.ki.hidden) return true;
    return hochSteht(spalteEl.hoch, nachSoll);
  }

  /** Die Entscheidung mit gemeldeten Kaesten (k, Messer) — gleiche Regeln wie gangLesen, ohne eigene Lesung.
   *  Sichtfeld aus rootBounds (Stufe 0 „je Gang frisch": jede Meldung ist frisch). */
  function gangAuswerten(opt, knopf, ziele, laschenEls, hinweis, k) {
    var nurHinaus = !!(opt && opt.nurHinaus);
    if (k && k.sicht) sichtH = k.sicht.height;
    else sichtLesen();
    var breiteSicht = k && k.sicht ? k.sicht.width : 0;
    if (!geeicht) eichen();
    var teile = spaltenTeile(knopf, !nurHinaus, breiteSicht);
    var spalte = teile ? teile.spalte : null;
    var laschen = nurHinaus ? null : laschenZoneAus(laschenEls, k, breiteSicht);
    var spalteWeicht = false;
    var laschenWeichen = false;
    if (spalte || laschen) {
      for (var i = 0; i < ziele.length; i++) {
        var el = ziele[i];
        var r = imBild(el, k);
        if (!r) continue;
        var inSpalte = !spalteWeicht && !!teile && decktEine(teile.zonen, r);
        var inLaschen = !laschenWeichen && deckt(laschen, r);
        if (!inSpalte && !inLaschen) continue;
        if (unsichtbar(el)) continue;
        if (inSpalte) spalteWeicht = true;
        if (inLaschen) laschenWeichen = true;
        if ((spalteWeicht || !teile) && (laschenWeichen || !laschen)) break;
      }
      if (!nurHinaus && !laschenWeichen && laschen && (schneidet(laschen, spalte) || schneidet(laschen, hinweisZoneAus(hinweis, k)))) laschenWeichen = true;
    }
    entscheidungSetzen(nurHinaus, spalteWeicht, laschenWeichen);
  }

  function entscheidungSetzen(nurHinaus, spalteWeicht, laschenWeichen) {
    if (nurHinaus) {
      if (spalteWeicht) klasse('ap-schwebe-weicht', true);
      return;
    }
    klasse('ap-schwebe-weicht', spalteWeicht);
    klasse('ap-laschen-weichen', laschenWeichen);
    melden('ap:schwebe-entschieden');
  }

  /** Der Gang OHNE IntersectionObserver (Rueckfall, Stand vor Phase D Teil 2): liest selbst. */
  function gangLesen(opt) {
    var nurHinaus = !!(opt && opt.nurHinaus);
    // SICHTHOEHE JE GANG FRISCH (Phase D Stufe 0, 05.10.2026). Beim Laden steht das Layout-Sichtfeld auf dem Handy
    // kurz breiter: gemessen in Chromium (Mobil-Emulation 375 x 667, Reifen-PDP) 750 x 1334 fuer 0,1–1 s NACH
    // DOMContentLoaded (vor load) — weder resize noch visualViewport-resize melden Anfang oder Ende, und auch das
    // Wurzelelement bleibt 375 px breit (ein ResizeObserver darauf meldet nichts; gemessen: 7 von 10 falsch). Startete
    // Teil 2 in diesem Fenster (Kaufleiste kommt), las sichtLesen() 1334 und blieb dabei: die Zonen der Spalte lagen
    // unter dem Bild, die Spalte wich auf der GANZEN Seite keinem Kaufknopf aus (Rekorder 375 x 667: 2 von 4 Laeufen
    // ohne ein einziges Ausweichen; 10 Ladevorgaenge: sichtH falsch bei 2 von 10, mit dem Stand 428f9d2 bei 7 von 10;
    // mit dieser Zeile 0 von 10). Der Gang laeuft im Leerlauf bzw. nach der Halt-Uhr und liest ohnehin (Ziele,
    // Kaesten) — EINE Lesung je Gang, nie im Scroll- oder Beobachter-Pfad.
    // Mit IntersectionObserver kommt die frische Sichthoehe aus der Meldung des Messers (gangAuswerten).
    sichtLesen();
    if (!geeicht) eichen();
    var knopf = knopfPruefen(nurHinaus);
    var teile = spaltenTeile(knopf, !nurHinaus);
    var spalte = teile ? teile.spalte : null;
    var laschen = nurHinaus ? null : laschenZone();
    var spalteWeicht = false;
    var laschenWeichen = false;
    if (spalte || laschen) {
      var liste = zieleImBild();
      for (var i = 0; i < liste.length; i++) {
        var el = liste[i];
        if (nurHinaus && !istKauf(el)) continue;
        var r = imBild(el);
        if (!r) continue;
        // EINE Spalte: ein Ziel unter IRGENDEINER Stufe laesst die ganze Spalte gleiten.
        var inSpalte = !spalteWeicht && !!teile && decktEine(teile.zonen, r);
        var inLaschen = !laschenWeichen && deckt(laschen, r);
        if (!inSpalte && !inLaschen) continue;
        if (unsichtbar(el)) continue;
        if (inSpalte) spalteWeicht = true;
        if (inLaschen) laschenWeichen = true;
        if ((spalteWeicht || !teile) && (laschenWeichen || !laschen)) break;
      }
      // Die Laschen weichen der GANZEN Spalte (auch dem KI-Platz und der Pille im Gespraech) und dem
      // offenen KI-Hinweis (hinweisZone).
      if (!nurHinaus && !laschenWeichen && laschen && (schneidet(laschen, spalte) || schneidet(laschen, hinweisZone()))) laschenWeichen = true;
    }
    entscheidungSetzen(nurHinaus, spalteWeicht, laschenWeichen);
  }

  /* -------------------------------------------------------------- Ablauf */

  /** modus: BILD (Bild-Lauf: Banner sammeln und messen), MESSEN (ResizeObserver: messen), sonst Beobachter-Pfad der
   *  Leiste — dort weder sammeln noch messen (kein getComputedStyle, kein Kasten im Mikrotask nach dem Klassenwechsel),
   *  das Faellige laeuft im naechsten Bild (Phase D Teil 2, P1 Massnahme 1: Banner einmal je Bild). */
  function rechnen(modus) {
    rechnenFaellig = false;
    if (!document.body) return;
    var imBildLauf = modus === BILD;
    var messen = imBildLauf || modus === MESSEN;
    if (imBildLauf && bannerNeu) pandectesSammeln();
    if (!imBildLauf && (bannerNeu || (bannerFaellig && !messen))) planen();
    var verdraengt = hindernisRechnen(messen);
    var aus = verdraengt || tastaturOffen();
    if (html.classList.contains('ap-schwebe-aus') !== aus) html.classList.toggle('ap-schwebe-aus', aus);
    // Das Google-Abzeichen haelt seinen Hub als Inline-transform (automotive.js) und rechnet nur auf Zuruf neu.
    var stand = standlinePx + '/' + hindernis;
    if (stand !== gemeldet) {
      gemeldet = stand;
      document.dispatchEvent(new CustomEvent('ap:standlinie', { detail: { standlinie: standlinePx, hindernis: hindernis } }));
    }
  }

  function bildLauf() {
    bildGeplant = false;
    if (rechnenFaellig) rechnen(BILD);
    if (weichenFaellig) weichenPruefen();
  }

  function bildPlanen() {
    if (bildGeplant) return;
    bildGeplant = true;
    window.requestAnimationFrame(bildLauf);
  }

  /** Rechnen im naechsten Bild (Fokus, Groesse, Banner) — zusammen mit einem anstehenden Ruhe-Gang. */
  function planen() {
    rechnenFaellig = true;
    bildPlanen();
  }

  /** EIN Ruhe-Gang im Leerlauf nach dem Start (Pruefrunde 2 Phase B, major: sonst lag die Blase auf der
   *  Befestiger-PDP bei scrollY 0 ueber dem Preisblock) — Frist 1,5 s. Davor werden die SCHUTZ-Ziele einmal
   *  gesammelt (Kopf Punkt 5 h). */
  function imLeerlaufPruefen() {
    var los = function () {
      schutzSammeln();
      pruefenWennRuhig();
    };
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(los, { timeout: 1500 });
    } else {
      window.setTimeout(los, 200);
    }
  }

  function wirteAktualisieren() {
    bannerNeu = true;
    if (document.querySelector('shopify-chat')) html.classList.add('ap-hat-chat');
    var vorher = spalteEl.chat;
    spalteHolen();
    // Ein spaeter gekommener Wirt der Blase bekommt sofort den gueltigen Hub (sonst stuende er auf der
    // Ruhelage des CSS, waehrend KI-Platz und „Nach oben" ueber der Leiste stehen).
    if (spalteEl.chat && spalteEl.chat !== vorher) {
      if (hubWert !== 0) hubSchreiben(hubWert);
      chatBeobachten(spalteEl.chat);
    }
    planen();
  }

  /** Ein Wirt kam oder ging (Chat, Banner, Zustimmung): ein Zustandswechsel — in Ruhe sofort neu entscheiden. */
  function wirteSuchen() {
    wirteAktualisieren();
    pruefenWennRuhig();
  }

  /** Spaete schwebende Elemente (P1 M11 [K14], ap:spaet-geladen aus P5): Wirte neu, ap:standlinie neu melden, einmal
   *  messen im naechsten Bild, entscheiden nur in Ruhe (nie im Wischen). Nicht schwebende Bausteine: keine Arbeit. */
  var SPAET_SCHWEBEND = ['abzeichen', 'inbox', 'judgeme-reiter', 'judgeme'];

  function spaetGeladen(e) {
    var anbieter = e && e.detail ? e.detail.anbieter : null;
    if (anbieter && SPAET_SCHWEBEND.indexOf(String(anbieter)) === -1) return;
    knopfVersuche = 0;
    gemeldet = null;
    wirteAktualisieren();
    pruefenWennRuhig();
  }

  /** Die Wirte der Schwebenden und Hindernisse, die Apps spaeter an den <body> haengen. Die Vorschauleiste
   *  (#PBarNextFrameWrapper) nicht mehr (G2, Kopf Punkt 1). */
  var WIRTE = 'pandectes-cmp, shopify-chat, #shopify-pc__banner';

  function istWirt(n) {
    return n && n.nodeType === 1 && typeof n.matches === 'function' && n.matches(WIRTE);
  }

  /* Die Ausloeser des Bildes — benannt, damit ein Vorab-Ausloeser (unten) sie fuer das Ereignis aufrufen
     kann, das ihn geweckt hat: ein Hoerer, der WAEHREND eines Ereignisses angemeldet wird, bekommt dieses
     Ereignis nicht mehr. */

  /** Scrollen: NUR die Uhren (Kopf Punkte 2 und 7) — kein Bild, keine Lesung, kein Ausweichen im Wischen. */
  function beimScrollen() {
    letzterScroll = jetzt();
    regung();
  }

  /** SCHLIESS-GANG (Kopf Punkt 4): eine Lade ging zu. Entschieden wird, sobald die Seite HALT_MS steht (gemessen ab
   *  dem Schliessen und ab dem letzten SCROLL — der Schliess-Tipp selbst zaehlt nicht) und kein Finger aufliegt;
   *  scrollt die Seite beim Schliessen (Dawn fokussiert den Oeffner der Bildansicht), erst nach dem Scroll. Laenger
   *  als LADE_ZU_MAX_MS nicht: dann entscheidet die naechste Ruhe (Teil 1 laesst ap-lade-zu dann ohnehin fallen). */
  var schliessUhr = 0;
  var schliessAb = 0;
  var SCHLIESS_MAX_MS = 1500;

  function schliessGangPlanen(ms) {
    if (schliessUhr) window.clearTimeout(schliessUhr);
    schliessUhr = window.setTimeout(schliessGang, Math.max(0, ms) + 10);
  }

  function schliessGang() {
    schliessUhr = 0;
    if (html.classList.contains('ap-lade-offen')) return; // wieder offen: das naechste Schliessen meldet sich
    var seitSchliessen = jetzt() - schliessAb;
    var seitScroll = jetzt() - letzterScroll;
    if (fingerHaelt() || seitSchliessen < HALT_MS || seitScroll < HALT_MS) {
      if (seitSchliessen < SCHLIESS_MAX_MS) schliessGangPlanen(Math.max(HALT_MS - Math.min(seitSchliessen, seitScroll), 50));
      else ruheWecken();
      return;
    }
    entschieden = true;
    melden('ap:schwebe-ruhe');
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(function () {
        weichenPruefen({ schliessen: true });
      }, { timeout: 100 });
    } else {
      weichenPruefen({ schliessen: true });
    }
  }

  // Groessenwechsel (auch die Adressleiste im Wischen): eine Regung. Geeicht wird nur, wenn sich die BREITE
  // aendert (Token je Breite, Safe-Area beim Drehen) — die Hoehe allein aendert keinen Token.
  // Gelesen beim Start von Teil 2, nicht beim Auswerten der Datei (Kopf Punkt 8).
  var geeichtBreite = 0;

  function neuMessen() {
    regung();
    sichtLesen();
    var breite = window.innerWidth;
    if (breite !== geeichtBreite) {
      geeichtBreite = breite;
      geeicht = false;
    }
    grundGueltig = false;
    bannerFaellig = true;
    planen();
  }

  function start() {
    // Teil 1 wartet beim Schliessen einer Lade ab jetzt auf die Entscheidung des Ruhe-Gangs (ap:schwebe-entschieden).
    html.__apSchwebeBereit = true;
    // Beim Start nur die Wirte; den EINEN Ruhe-Gang meldet imLeerlaufPruefen an (G2). Die drei Groessen, die bis
    // Phase D Teil 2 beim Auswerten der Datei gelesen wurden (Kopf Punkt 8), liest erst dieser Start.
    sichtLesen();
    if (!hoeheOhneTastatur) hoeheOhneTastatur = sichtH;
    geeichtBreite = window.innerWidth;
    wirteAktualisieren();
    // Neue Wirte (Pandectes, Chat) haengen die Apps spaeter an den <body>. Nur hinzugefuegte oder entfernte
    // WIRTE zaehlen (DT-1): Apps haengen laufend Skript- und Stilknoten an.
    new MutationObserver(function (liste) {
      for (var i = 0; i < liste.length; i++) {
        var r = liste[i];
        for (var a = 0; a < r.addedNodes.length; a++) if (istWirt(r.addedNodes[a])) return wirteSuchen();
        for (var e = 0; e < r.removedNodes.length; e++) if (istWirt(r.removedNodes[e])) return wirteSuchen();
      }
    }).observe(document.body, { childList: true });
    // Ziele im Hauptinhalt kommen und gehen (Kopf Punkt 5 h): entprellt neu sammeln.
    var haupt = document.getElementById('MainContent');
    if (haupt) new MutationObserver(sammelnPlanen).observe(haupt, { childList: true, subtree: true });
    window.addEventListener('resize', neuMessen, { passive: true });
    window.addEventListener('orientationchange', function () {
      hoeheOhneTastatur = 0;
      neuMessen();
    });
    window.addEventListener('scroll', beimScrollen, { passive: true });
    window.addEventListener('touchstart', fingerAuf, { passive: true, capture: true });
    window.addEventListener('touchend', fingerAb, { passive: true, capture: true });
    window.addEventListener('touchcancel', fingerAb, { passive: true, capture: true });
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', function () {
        regung();
        sichtLesen();
        bannerFaellig = true;
        grundGueltig = false;
        // Nur, wenn es etwas zu entscheiden gibt (Tastatur, unten verankerter Banner) — die Adressleiste
        // im Wischen loest sonst keinen Rechenlauf aus.
        if (editierbarImFokus() || bannerElemente.length) planen();
      });
      window.visualViewport.addEventListener('scroll', beimScrollen);
    }
    document.addEventListener('focusin', planen);
    document.addEventListener('focusout', planen);
    // Shopify Customer Privacy (Pandectes meldet dorthin): der Banner geht nach der Antwort.
    document.addEventListener('visitorConsentCollected', wirteSuchen);
    // Spaet geladene schwebende Bausteine (P5, Kopf Punkt 8 [K14]).
    document.addEventListener('ap:spaet-geladen', spaetGeladen);
    // Eine Lade ging zu (Teil 1, Kopf Punkt 4): der Schliess-Gang entscheidet, sobald die Seite HALT_MS steht —
    // die Spalte ist bis dahin verborgen (ap-lade-zu faellt erst nach der Entscheidung).
    document.addEventListener('ap:lade', function (e) {
      if (!e || !e.detail || e.detail.offen !== false) return;
      entschieden = false;
      schliessAb = jetzt();
      schliessGangPlanen(HALT_MS);
    });
    // Der KI-Platz erscheint ([hidden] weg) oder waechst im Gespraech auf die Pille (Ereignis ap:ki-platz aus
    // ap-ki-widget.js — NICHT das style-Attribut: dort schreibt diese Datei den Hub). Der Hinweis geht auf
    // oder zu ([hidden]): die Laschen weichen ihm bzw. kommen zurueck (hinweisZone).
    // Gegenpruefung 03.10.2026 (Querformat 844x390): bis zum ersten Scrollen lag die Judge.me-Lasche
    // „Bewertungen" ueber dem KI-Knopf — ein Zustandswechsel in Ruhe prueft deshalb sofort.
    var ki = spalteEl.ki;
    if (ki) {
      new MutationObserver(pruefenWennRuhig).observe(ki, { attributes: true, attributeFilter: ['hidden'] });
      ki.addEventListener('ap:ki-platz', pruefenWennRuhig);
      var kiHinweis = ki.querySelector('.ap-ki__hinweis');
      if (kiHinweis) new MutationObserver(pruefenWennRuhig).observe(kiHinweis, { attributes: true, attributeFilter: ['hidden'] });
    }
    imLeerlaufPruefen();
  }

  /* ---------------------------------------------------------- Startzeit (G2) */

  /** Spaetester Start nach `load`, auch wenn der Hauptfaden nie ruht (requestIdleCallback-timeout). */
  var LEERLAUF_MS = 2000;
  var gestartet = false;
  var vorab = [];
  var leisteWache = null;

  /** Startet Teil 2 genau einmal und meldet die Vorab-Ausloeser ab. true = jetzt gestartet. */
  function losLegen() {
    if (gestartet) return false;
    gestartet = true;
    for (var i = 0; i < vorab.length; i++) vorab[i][0].removeEventListener(vorab[i][1], vorab[i][2], vorab[i][3]);
    vorab = [];
    if (leisteWache) leisteWache.disconnect();
    leisteWache = null;
    start();
    return true;
  }

  function vorabHoeren(ziel, typ, fn, opt) {
    ziel.addEventListener(typ, fn, opt);
    vorab.push([ziel, typ, fn, opt]);
  }

  function imLeerlauf() {
    if (typeof window.requestIdleCallback === 'function') window.requestIdleCallback(losLegen, { timeout: LEERLAUF_MS });
    else window.setTimeout(losLegen, 1);
  }

  function leisteSichtbar(el) {
    return !el.hidden && el.classList.contains('is-visible');
  }

  function vorbereiten() {
    // FRUEHER, wenn es etwas zu tun gibt — sonst bliebe die Spalte bis zum Leerlauf in der Kaufleiste
    // (Tablet: die Leiste steht schon im ersten Bildschirm) oder ueber der Tastatur.
    var passiv = { passive: true };
    vorabHoeren(window, 'scroll', function () {
      if (losLegen()) beimScrollen();
    }, passiv);
    vorabHoeren(window, 'resize', function () {
      if (losLegen()) neuMessen();
    }, passiv);
    vorabHoeren(window, 'touchstart', function (e) {
      if (losLegen()) fingerAuf(e);
    }, { passive: true, capture: true });
    vorabHoeren(document, 'focusin', losLegen);
    var leiste = document.querySelector('sticky-atc.ap-sticky-atc');
    if (leiste) {
      if (leisteSichtbar(leiste)) {
        losLegen();
        return;
      }
      // Wie `aenderungen`: SOFORT rechnen, damit die Spalte im selben Stilschritt wie die Leiste anlaeuft.
      leisteWache = new MutationObserver(function () {
        if (leisteSichtbar(leiste) && losLegen()) rechnen();
      });
      leisteWache.observe(leiste, { attributes: true, attributeFilter: ['class', 'hidden'] });
    }
    if (document.readyState === 'complete') imLeerlauf();
    else vorabHoeren(window, 'load', imLeerlauf, { once: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', vorbereiten, { once: true });
  } else {
    vorbereiten();
  }
})();
